﻿export default class ListControl {
    constructor(options) {
        this.isPreview = options.IsPreview;
        this.idMediaField = options.IdMediaField;
        this.layoutResources = options.LayoutResources;
        this.formMetadata = options.FormMetadata;
        this.filterId = options.FilterId;
        this.entityId = options.IdEntity;
        this.listId = options.Id;
        this.idExtConn = options.IdExtConn;
        this.listDescription = options.Description;
        this.listName = options.Name;
        this.currentUrl = options.CurrentUrl;
        this.containerId = options.ContainerId;
        this.getDataUrl = options.GetDataUrl;
        this.getDataPostParam = options.GetDataPostParam;
        this.editItemUrl = options.EditItemUrl;
        this.editItemPostParam = options.EditItemPostParam;
        this.displayContext = options.Context;
        this.uiActionResources = options.UiActionResources;
        this.listType = options.ListType;
        this.uniqueId = options.PageGuid.replaceAll('-', '');
        this.uniqueControlId = 'listControl' + this.uniqueId;
        this.fieldPrefix = 'fld_';
        this.uiLayoutId = options.uiLayoutId;
        this.parentPkVal = options.parentPkVal;
        this.rootUrl = options.RootUrl;
        this.itemActions = options.ItemButtons;
        this.groupable = this.listType == 'TREE' ? false : options.Groupable;
        this.idField = options.PkFieldName;
        this.pageUniqueIdentifier = options.PageGuid;
        this.pageType = this.listType == 'TREE' ? 'CLIENT_PAGING' : options.PageType;
        this.returnUrl = options.ReturnUrl;
        this.sortType = options.SortType;
        this.parent = options.Parent;
        this.onBeforeListLoaded = typeof options.onBeforeListLoaded === 'function' ? options.onBeforeListLoaded : null;
        this.onListLoaded = typeof options.onListLoaded === 'function' ? options.onListLoaded : null;
        this.onFilterLoaded = typeof options.onFilterLoaded === 'function' ? options.onFilterLoaded : null;
        this.styleApplied = false;
        this.currentCsvCommand = null;
        this.urlParameters = options.UrlParameters;
        this.pageable = {
            pageSize: 10,
            pageSizes: [10, 25, 50, 100]
        };
        this.generalResources = options.GeneralResources;
        this.entityFormResources = options.EntityFormResources;
        this.listControlId = ('entity_list_' + this.uniqueId).replaceAll('-', '_');
        this.listControlCarouselId = this.listControlId + '_carousel';
        this.listControlTitleId = ('entity_list_title_' + this.uniqueId).replaceAll('-', '_');
        this.csvInputId = ('entity_list_csv_input_' + this.uniqueId).replaceAll('-', '_');
        this.filterControlId = 'filter-control-id' + this.uniqueId;
        this.modalInner = 'sublist-modal-' + this.uniqueId;
        this.modalWrapperUniqueId = 'list-modal-' + this.uniqueId;
        this.filterControl = null;
        this.filters = {};
        this.toolbarActions = this.getToolbarButtons(options.ToolbarButtons);
        this.fields = this.extractFields(options.Fields);
        this.selectionType = options.SelectType;
        this.uid = options.Uid;
        this.lastListHeight = null;
        this.commands = options.XpCommands;
        this.selectedIds = {};
        this.isPageChange = false;
        this.hasActions = true;
        this.destroy();
        $('#' + this.containerId)[0][this.uniqueControlId] = this;
        //Hardcodare Radu
        const namesToDisable = ["Asociere notificare SNUAU 112 la Eveniment"];
        this.autoBind = namesToDisable.includes(this.listName)
            ? false
            : (options.Autobind != null ? options.Autobind : true);
        this.initListControl();
        this.lastHeaderWidth = 0;

        if (xapp && xapp.currentAppType && this.listName && this.listName != '' && this.parent == null && !this.isPreview) {
            document.title = this.listName;
        }
    }

    openUrl(url, target) {
        if (url == null || url.trim().length == 0) {
            return;
        }

        if (url.indexOf(this.rootUrl) > 0 && url.indexOf('idApp') < 0) {
            if (url.indexOf('?') > 0 || url.indexOf('&') > 0) {
                url += '&idApp=' + xapp.currentApp;
            } else {
                url += '?idApp=' + xapp.currentApp;
            }
        }

        window.open(url, target);
    }

    reloadList(options) {
        this.styleApplied = false;
        $('#' + this.containerId)[0].innerHTML = '';
        this.listDescription = options.Description;
        this.listType = options.ListType;
        this.listName = options.Name;
        this.toolbarActions = this.getToolbarButtons(options.ToolbarButtons);
        this.itemActions = options.ItemButtons;
        this.fields = this.extractFields(options.Fields);
        this.groupable = options.Groupable;
        this.idField = options.PkFieldName;
        this.pageType = options.PageType;
        this.sortType = options.SortType;
        this.initListControl();
    }

    destroy() {
        if ($('#' + this.containerId).length > 0) {
            $('#' + this.containerId)[0].innerHTML = '';
        }
    }

    filterLoaded() {
        if (window['onFilterLoaded' + this.uniqueId] != null && !this.isPreview) {
            window['onFilterLoaded' + this.uniqueId]();
        }
        if (window['onFilterLoaded' + '_' + this.listId] != null && !this.isPreview) {
            window['onFilterLoaded' + '_' + this.listId](this);
        }
        if (this.onFilterLoaded != null) {
            this.onFilterLoaded(this);
        }

        if (this.parent != null) {
            this.parent.sublistFilterLoaded(this.containerId);
        }

        const namesToDisable = ["Asociere notificare SNUAU 112 la Eveniment"];

        let isAutobind = namesToDisable.includes(this.listName) ? false : this.autoBind;

        if (isAutobind) {
            this.applyFilters(true);
        }
    }

    _loadCommands() {
        let commandsUrl = rootUrl + 'XpCommand/GetXpCommandsRuntime?ownerType=EntityList&id=' + this.listId;
        return new Promise((resolve, reject) => {
            if (this.isPreview) {
                resolve();
            } else {
                $.ajax({
                    type: "GET",
                    url: commandsUrl,
                    contentType: "application/json; charset=utf-8",
                    async: true,
                    success: (result) => {
                        this.commands = result;
                        resolve();
                    },
                    error: (e) => {
                        toastr.error(e.responseText);
                        resolve();
                    }
                });
            }
        });
    }

    _storeWidget(widget, id) {
        if (window.widgetRegistry == null) {
            window.widgetRegistry = {};
        }

        window.widgetRegistry[id] = widget;
    }

    applyFilters(validate) {
        if (this.filterControl != null) {
            this.filterControl.applyFilters(validate);
        }
    }

    initListControl() {
        this.initStructure();

        if (sessionStorage.getItem('listFilterHolder') == null) {
            sessionStorage.setItem('listFilterHolder', '{}');
        }

        let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));

        if (listFilterHolder[this.uid] == null) {
            listFilterHolder[this.uid] = {};
            sessionStorage.setItem('listFilterHolder', JSON.stringify(listFilterHolder));
        }

        if (this.listType == 'GRID' || this.listType == 'TREE' || this.listType == null || this.listType == '') {
            this.filterControl = new FormControl({
                localization: this.layoutResources,
                actionLocalization: this.uiActionResources,
                isPreview: this.isPreview,
                container: this.filterControlId,
                pageGuid: this._generateUUID(),
                objectId: '0',
                listId: this.listId,
                idExtConn: this.idExtConn,
                layoutId: this.filterId,
                isFilter: true,
                listControl: (this.isPreview ? null : this),
                generalResources: this.generalResources,
                customFormResources: this.customFormResources,
                XpCommands: this.commands
            });

            if (this.filterId != -1) {
                $.ajax({
                    type: "GET",
                    url: rootUrl + 'UILayout/GetUILayoutRuntime?id=' + this.filterId,
                    contentType: "application/json; charset=utf-8",
                    async: true,
                    success: (result) => {
                        this.formMetadata = result
                        this.filterControl.loadForm(this.formMetadata, []);
                    },
                    error: (e) => {
                        toastr.error(e.responseText, this.getGeneralResource('GetLayoutError'));
                    }
                });
            } else {
                const namesToDisable = ["Asociere notificare SNUAU 112 la Eveniment"];
                let isAutobind = namesToDisable.includes(this.listName) ? false : this.autoBind;

                if (isAutobind) {
                    this.refresh();
                }
            }
        }

        if (window['onBeforeListLoaded' + this.uniqueId] != null && !this.isPreview) {
            window['onBeforeListLoaded' + this.uniqueId]();
        }
        if (window['onBeforeListLoaded' + '_' + this.listId] != null && !this.isPreview) {
            window['onBeforeListLoaded' + '_' + this.listId](this);
        }
        if (this.onBeforeListLoaded != null) {
            this.onBeforeListLoaded(this);
        }

        switch (this.listType) {
            case 'GRID': this._initGridControl();
                break;
            case 'CAROUSEL': this._initCarouselControl();
                break;
            default: this._initGridControl();
                break;
        }

        if (window['onListLoaded' + this.uniqueId] != null && !this.isPreview) {
            window['onListLoaded' + this.uniqueId]();
        }

        if (window['onListLoaded' + '_' + this.listId] != null && !this.isPreview) {
            window['onListLoaded' + '_' + this.listId](this);
        }
        if (this.onListLoaded != null) {
            this.onListLoaded(this);
        }
    }

    executeCommandById(id, params, item) {
        let foundCommands = this.commands.filter((row) => { return row.Id == id });

        if (foundCommands.length > 0) {
            return this._executeCommand(foundCommands[0], params, item);
        } else {
            return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
        }
    }

    executeCommandByName(name, params, item) {
        let foundCommands = this.commands.filter((row) => { return row.Name == name });

        if (foundCommands.length > 0) {
            if (foundCommands.length > 0) {
                return this._executeCommand(foundCommands[0], params, item);
            } else {
                return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
            }
        } else {
            return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
        }
    }

    executeTemplate(idTemplate, params) {
        return new Promise((resolve, reject) => {
            try {
                let postData = {
                    id: idTemplate,
                    idList: this.listId,
                    filters: JSON.stringify(this.filters),
                    params: {}
                };

                if (params != null) {
                    postData.params = params;
                }

                let url = rootUrl + 'EntityList/ExecuteTemplate';

                $.ajax({
                    type: "POST",
                    url: url,
                    async: true,
                    data: JSON.stringify(postData),
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        if (result != null) {
                            resolve(result);
                        }
                    },
                    error: (e) => {
                        reject(e)
                    }
                });
            } catch (err) {
                reject(err);
            }
        });
    }

    refresh() {
        setTimeout(() => {
            this._getGridControl().dataSource.read();
        }, 100);
    }

    _getGridControl() {
        if (this.listType == 'GRID') {
            return $('#' + this.listControlId).data('kendoGrid');
        } else if (this.listType == 'TREE') {
            return $('#' + this.listControlId).data('kendoTreeList');
        }
    }

    getSelected() {
        return Object.keys(this.selectedIds);
    }

    _executeCommand(command, params, item) {
        if (command.Type == 'CLIENT') {
            return new Promise((resolve, reject) => {
                try {
                    if (window['xp_command_' + command.Id] != null) {
                        let result = window['xp_command_' + command.Id](this);
                        resolve(result);
                    }
                    else if (window['xp_command_' + this.uniqueId + '_' + command.Id] != null) {
                        let result = window['xp_command_' + this.uniqueId + '_' + command.Id](this);
                        resolve(result);
                    }
                    else {
                        //CG: fara functia client inregistrata promise-ul ramanea nesolutionat la infinit
                        //(nici resolve, nici reject); respingem explicit si logam, ca lipsa sa fie vizibila
                        let message = 'Client command not registered: xp_command_' + command.Id;
                        console.error(message);
                        reject(message);
                    }
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_WITH_RESULT' || command.Type == 'C_SHARP_WITH_RESULT') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        filters: JSON.stringify(this.filters),
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    } else if (item != null) {
                        for (var i = 0; i < command.Parameters.length; i++) {
                            let field = item[command.Parameters[i]];

                            if (command.Parameters[i] != 'User.Id' && field != null) {
                                let type = field.fieldDataType;

                                postData.params[command.Parameters[i]] = {
                                    value: field.value,
                                    type: type
                                }
                            }
                        }
                    } else {
                        reject('Cannot autodetect parameters for command!');
                    }

                    let commandUrl = rootUrl + 'XpCommand/ExecuteCommandWithResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                if (result.Error != null) {
                                    reject(result.Error);
                                }
                                else {
                                    var resp = JSON.parse(result);

                                    if (resp.length == 0) {
                                        resolve(null);
                                    } else if (resp.length == 1) {
                                        resolve(resp[0]);
                                    } else {
                                        resolve(resp);
                                    }
                                }
                                
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_NO_RESULT' || command.Type == 'C_SHARP_NO_RESULT' || command.Type == 'SEND_EMAIL') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        filters: JSON.stringify(this.filters),
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    } else if (item != null) {
                        for (var i = 0; i < command.Parameters.length; i++) {
                            let field = item[command.Parameters[i]];

                            if (command.Parameters[i] != 'User.Id' && field != null) {
                                let type = field.fieldDataType;

                                postData.params[command.Parameters[i]] = {
                                    value: field.value,
                                    type: type
                                }
                            }
                        }
                    } else {
                        reject('Cannot autodetect parameters for command!');
                    }

                    let commandUrl = rootUrl + 'XpCommand/ExecuteCommandWithoutResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                if (result.Error != null) {
                                    reject(result.Error);
                                }
                                else {
                                    if (result.status == true) {
                                        resolve(true);
                                    } else {
                                        resolve(false);
                                    }
                                }                                
                            } else {
                                resolve(false);
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else {
            return new Promise((resolve, reject) => { return reject('Command type not implemented!'); });
        }
    }

    _initCarouselControl() {
        if (this.isPreview) {
            this._initPreviewCarouselControl();
        } else {
            let dataSourceUrl = '';

            if (this.getDataUrl == null || this.getDataUrl.trim() == '') {
                if (this.parent != null) {
                    dataSourceUrl = 'EntityList/GetSubListData';
                } else {
                    dataSourceUrl = 'EntityList/GetData';
                }
            } else {
                dataSourceUrl = this.getDataUrl.substring(1);
            }

            let data = {};

            if (this.parent != null) {
                dataSourceUrl += '?idUISubList=' + this.uiLayoutId + '&pkVal=' + this.parentPkVal;
            } else {
                dataSourceUrl += '?id=' + this.listId;
            }
            dataSourceUrl += '&filters=' + JSON.stringify(this.filters);
            if (this.idExtConn != null) {
                dataSourceUrl += '&idExtConn=' + this.idExtConn;
            }
            dataSourceUrl = this.rootUrl + dataSourceUrl;

            if (this.displayContext == 'modal' && this.parent == null) {
                $('#' + this.containerId).closest('.k-window-content').data('kendoWindow').center();
                if (this._checkMobile()) {
                    $('#' + this.listControlId).closest('.k-window').css({ top: "3.8rem", position: 'fixed' });
                }
            }

            $.ajax({
                async: true,
                type: "GET",
                url: dataSourceUrl,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    this._initRuntimeCarouselControl(result);
                },
                error: (e) => {
                    toastr.error(e.responseText, this.getEntityFormResources('GetListError'));
                }
            });
        }
    }

    _initRuntimeCarouselControl(remoteData) {
        let runtimeDataset = [];

        remoteData.Data.forEach(item => {
            let remoteItem = {};

            this.fields.forEach(field => {
                remoteItem[field.id] = {
                    value: item[field.id],
                    fieldDataType: field.fieldDataType,
                    name: field.name,
                    format: field.format,
                    width: field.width,
                    controlType: field.controlType,
                    htmlAttributes: field.htmlAttributes,
                    id: field.id
                }
            });

            if (item['fld_0'] != null) {
                remoteItem['fld_0'] = {
                    value: item['fld_0'] == true ? (this.rootUrl + 'Entity/GetFileContent?idEntityField=' + this.idMediaField + '&pkVal=' + item[this.idField]) : null,
                    mimeType: item['fld_0_xp_mimeType'],
                    fileName: item['fld_0_xp_fileName'],
                    controlType: 'IMAGE',
                    id: 'fld_0'
                }
            }

            remoteItem.pkVal = item[this.idField];
            runtimeDataset.push(remoteItem);
        });

        $('#' + this.listControlId).parent().append(`<div id="` + this.modalWrapperUniqueId + `"></div>`);

        $('#' + this.listControlId).append(this._getCarouselTemplate(runtimeDataset));

        this._addEventsForActionButtons();
        this._wireCarouselZoom();
    }

    _initPreviewCarouselControl() {
        let previewData = this.getPreviewData(3);
        let previewDataset = [];

        previewData.Data.forEach(item => {
            let keys = Object.keys(item);
            let previewItem = {};

            keys.forEach(key => {
                let fieldItems = this.fields.filter(row => { return row.id == key });

                if (fieldItems.length == 1) {
                    let fieldItem = fieldItems[0];
                    previewItem[key] = {
                        value: item[key],
                        fieldDataType: fieldItem.fieldDataType,
                        name: fieldItem.name,
                        format: fieldItem.format,
                        width: fieldItem.width,
                        controlType: fieldItem.controlType,
                        htmlAttributes: fieldItem.htmlAttributes,
                        id: key
                    }
                }
            });

            previewDataset.push(previewItem);
        });

        $('#' + this.listControlId).append(this._getCarouselTemplate(previewDataset));
        this._wireCarouselZoom();
    }

    _getFileIconClass(contentType) {
        if (contentType.indexOf('msword') >= 0 || contentType.indexOf('wordprocessingml') >= 0 || contentType.indexOf('opendocument.text') >= 0) return 'fa-file-word';
        if (contentType.indexOf('spreadsheetml') >= 0 || contentType.indexOf('ms-excel') >= 0 || contentType.indexOf('opendocument.spreadsheet') >= 0) return 'fa-file-excel';
        if (contentType.indexOf('presentationml') >= 0 || contentType.indexOf('ms-powerpoint') >= 0 || contentType.indexOf('opendocument.presentation') >= 0) return 'fa-file-powerpoint';
        if (contentType.indexOf('zip') >= 0 || contentType.indexOf('compressed') >= 0) return 'fa-file-archive';
        if (contentType.indexOf('text/') === 0) return 'fa-file-alt';
        if (contentType.indexOf('audio/') === 0) return 'fa-file-audio';
        if (contentType.indexOf('video/') === 0) return 'fa-file-video';
        return 'fa-file';
    }

    _wireCarouselZoom() {
        var ref = this;
        $('#' + this.listControlId)
            .off('click.xpCarouselZoom')
            .on('click.xpCarouselZoom', '.xp-carousel-expand, .xp-carousel-img', function (e) {
                e.stopPropagation();
                var src = $(this).attr('data-full-src');
                if (!src) return;

                var ct = ($(this).attr('data-content-type') || '').toLowerCase();

                const frame = this.closest(".xp-carousel-img-frame");
                if (frame == null) return;
                const img = frame.querySelector(".xp-carousel-img");

                var angle = img.dataset?.rotation;
                if (!angle) {
                    angle = 0;
                }
                else {
                    angle = parseInt(angle);
                }
                ref._openCarouselContent(src, ct, angle);
            })
            .on('click', '.xp-carousel-rotate-left, .xp-carousel-img', function (e) {
                e.stopPropagation();
                const frame = this.closest(".xp-carousel-img-frame");
                if (frame == null) return;
                const img = frame.querySelector(".xp-carousel-img");
                if (img == null) return;

                var angle = img.dataset?.rotation;
                if (!angle) {
                    angle = 0;
                }
                else {
                    angle = parseInt(angle);
                }
                angle -= 90;
                if (angle < 0) angle = 360 + angle;
                img.style.transformOrigin = 'center center'
                img.style.transform = 'rotate(' + angle + 'deg)'
                img.dataset.rotation = angle;
            })
            .on('click', '.xp-carousel-rotate-right, .xp-carousel-img', function (e) {
                e.stopPropagation();
                const frame = this.closest(".xp-carousel-img-frame");
                if (frame == null) return;
                const img = frame.querySelector(".xp-carousel-img");
                if (img == null) return;
                var angle = img.dataset?.rotation;
                if (!angle) {
                    angle = 0;
                }
                else {
                    angle = parseInt(angle);
                }
                angle += 90;
                if (angle > 360) angle = angle - 360;
                img.style.transformOrigin = 'center center'
                img.style.transform = 'rotate(' + angle + 'deg)'
                img.dataset.rotation = angle;
            })
            ;
    }

    _openCarouselContent(src, contentType, angle) {
        if (contentType === '' || contentType.indexOf('image/') === 0) {
            this._openImageZoom(src, angle);
        } else if (contentType.indexOf('application/pdf') >= 0) {
            this._openPdfViewer(src);
        } else {
            window.open(src, '_blank');
        }
    }

    _openPdfViewer(src) {
        var $holder = $('<div></div>').appendTo('body');
        $holder.html(
            '<iframe src="' + src + '" style="width: 100%; height: 100%; border: 0;"></iframe>'
        );
        $holder.kendoWindow({
            modal: true,
            draggable: true,
            resizable: true,
            width: '80%',
            height: '80%',
            close: function () {
                this.destroy();
                $holder.remove();
            }
        }).data('kendoWindow').center().open();
    }

    _openImageZoom(src, angle) {
        var $holder = $('<div></div>').appendTo('body');
        var styleRotate = '';
        var toolbarHtml =
            '<div class="xp-zoom-toolbar" style="position: absolute; top: 8px; left: 50%; transform: translateX(-50%); z-index: 2; display: flex; gap: 4px; background: rgba(255,255,255,0.9); border: 1px solid #ccc; border-radius: 4px; padding: 4px;">' +
                '<button type="button" class="btn btn-sm btn-light xp-zoom-out" title="Zoom out"><i class="fa fa-search-minus"></i></button>' +
                '<button type="button" class="btn btn-sm btn-light xp-zoom-fit" title="Fit"><i class="fa fa-expand"></i></button>' +
                '<button type="button" class="btn btn-sm btn-light xp-zoom-actual" title="1:1">1:1</button>' +
                '<button type="button" class="btn btn-sm btn-light xp-zoom-in" title="Zoom in"><i class="fa fa-search-plus"></i></button>' +
            '</div>';
        $holder.html(
            '<div class="xp-zoom-viewport" style="position: relative; width: 100%; height: 100%; overflow: hidden; background: #f5f5f5; cursor: grab; user-select: none;">' +
                toolbarHtml +
            '<img class="xp-zoom-img" src="' + src + '" draggable="false" style="position: absolute; left: 0; top: 0; transform-origin: center center; max-width: none; max-height: none; user-select: none; -webkit-user-drag: none;">' +
            '</div>'
        );
        var state = { scale: 1, tx: 0, ty: 0, fitScale: 1, natW: 0, natH: 0 };
        var win = $holder.kendoWindow({
            modal: true,
            draggable: true,
            resizable: true,
            width: '80%',
            height: '80%',
            close: function () {
                this.destroy();
                $holder.remove();
            },
            resize: function () { applyFit(); }
        }).data('kendoWindow');

        var $viewport = $holder.find('.xp-zoom-viewport');
        var $img = $holder.find('.xp-zoom-img');
        $img[0].dataset.rotation = angle;

        function apply() {
            var angle = $img[0].dataset.rotation;
            if (!angle) angle = 0;
            $img.css('transform', 'translate(' + state.tx + 'px, ' + state.ty + 'px) scale(' + state.scale + ') rotate(' + angle + 'deg)');
        }
        function applyFit() {
            if (!state.natW || !state.natH) return;
            var vw = $viewport.width();
            var vh = $viewport.height();
            var s = Math.min(vw / state.natW, vh / state.natH, 1);
            state.fitScale = s;
            state.scale = s;
            state.tx = (vw - state.natW * s) / 2;
            state.ty = (vh - state.natH * s) / 2;
            apply();
        }
        function zoomAt(factor, cx, cy) {
            var newScale = Math.max(state.fitScale * 0.25, Math.min(20, state.scale * factor));
            if (newScale === state.scale) return;
            state.tx = cx - (cx - state.tx) * (newScale / state.scale);
            state.ty = cy - (cy - state.ty) * (newScale / state.scale);
            state.scale = newScale;
            apply();
        }

        $img.on('load', function () {
            state.natW = this.naturalWidth || this.width;
            state.natH = this.naturalHeight || this.height;
            applyFit();
        });

        $holder.find('.xp-zoom-in').on('click', function () {
            zoomAt(1.25, $viewport.width() / 2, $viewport.height() / 2);
        });
        $holder.find('.xp-zoom-out').on('click', function () {
            zoomAt(1 / 1.25, $viewport.width() / 2, $viewport.height() / 2);
        });
        $holder.find('.xp-zoom-fit').on('click', function () { applyFit(); });
        $holder.find('.xp-zoom-actual').on('click', function () {
            var vw = $viewport.width();
            var vh = $viewport.height();
            state.scale = 1;
            state.tx = (vw - state.natW) / 2;
            state.ty = (vh - state.natH) / 2;
            apply();
        });

        $viewport.on('wheel', function (e) {
            e.preventDefault();
            var rect = $viewport[0].getBoundingClientRect();
            var cx = e.originalEvent.clientX - rect.left;
            var cy = e.originalEvent.clientY - rect.top;
            var factor = e.originalEvent.deltaY < 0 ? 1.15 : 1 / 1.15;
            zoomAt(factor, cx, cy);
        });

        var dragging = false;
        var dragStart = { x: 0, y: 0, tx: 0, ty: 0 };
        $viewport.on('mousedown', function (e) {
            if ($(e.target).closest('.xp-zoom-toolbar').length) return;
            dragging = true;
            dragStart.x = e.clientX;
            dragStart.y = e.clientY;
            dragStart.tx = state.tx;
            dragStart.ty = state.ty;
            $viewport.css('cursor', 'grabbing');
            e.preventDefault();
        });
        $(document).on('mousemove.xpZoom', function (e) {
            if (!dragging) return;
            state.tx = dragStart.tx + (e.clientX - dragStart.x);
            state.ty = dragStart.ty + (e.clientY - dragStart.y);
            apply();
        });
        $(document).on('mouseup.xpZoom', function () {
            if (!dragging) return;
            dragging = false;
            $viewport.css('cursor', 'grab');
        });

        win.bind('close', function () {
            $(document).off('mousemove.xpZoom mouseup.xpZoom');
        });

        win.center();
        win.open();
    }

    _getCarouselTemplate(items) {
        let template = `<div class="col-sm-12 mb-2 pr-0">
                            <div class="form-group d-flex">`;

        for (let i = 0; i < this.toolbarActions.length; i++) {
            let toolbarAction = this.toolbarActions[i];

            let ml = 'ml-2';

            if (i == 0) {
                ml = 'ml-auto';
            }

            let classPart = toolbarAction.attr.substr(toolbarAction.attr.indexOf('class="') + 'class="'.length);
            let actualClass = classPart.substr(0, classPart.indexOf('"'));
            toolbarAction.attr = toolbarAction.attr.replaceAll('class="' + actualClass + '"', '');
            toolbarAction.attr += 'class="' + actualClass + ' ' + ml + ' btn"';

            let actionButtonIconTemplate = ``;

            if (toolbarAction.iconClass != null && toolbarAction.iconClass != '') {
                actionButtonIconTemplate = `<i class="` + toolbarAction.iconClass + ` mr-2"></i>`
            }

            template += `<button ` + toolbarAction.attr + ` title="` + toolbarAction.text + `" style="line-height: 1.2rem;">` + actionButtonIconTemplate + `<span>` + toolbarAction.text + `</span>` + `</button>`
        };

        template += `</div></div>`;

        template += `<div id="` + this.listControlCarouselId + `" class="carousel slide" data-ride="carousel" style="` + (this.toolbarActions.length > 0 ? `height: calc(100% - 2rem);` : `height: 100%;`) + `">`;

        template += `<ol class="carousel-indicators">`;

        for (let i = 0; i < items.length; i++) {
            template += `<li data-target="#` + this.listControlCarouselId + `" data-slide-to="` + i + `" class="` + (i == 0 ? `active` : ``) + `"></li>`;
        }

        template += `</ol>`;

        template += `<a class="carousel-control-prev" href="#` + this.listControlCarouselId + `" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#` + this.listControlCarouselId + `" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>`;

        template += `<div class="carousel-inner" style="height: 100%;">`;

        for (let i = 0; i < items.length; i++) {
            template += `<div class="carousel-item` + (i == 0 ? ` active` : ``) + `" style="height: 100%;">`;
            template += `<div style="width: 100%; height: 100%; justify-content: center; display: flex; ">`;

            let imageField = this._getCarouselImageField(items[i]);

            if (imageField == null || imageField.value == null) {
                if (this.isPreview) {
                    imageField = {
                        id: 'fld_0',
                        value: this.rootUrl + 'img/card-backgrounds/cover-' + ((i % 3) + 1) + '-lg.png',
                        mimeType: 'image/png'
                    }
                } else {
                    imageField = {
                        id: 'fld_0',
                        value: this.rootUrl + 'img/fnf.png',
                        mimeType: 'image/png'
                    }
                }
            }

            let mimeType = (imageField.mimeType || '').toLowerCase();
            let contentHtml;

            if (mimeType.indexOf('image/') === 0 || mimeType === '') {
                contentHtml = `<img class="d-block xp-carousel-img" src="` + imageField.value + `" data-full-src="` + imageField.value + `" data-content-type="` + mimeType + `" style="max-width: 100%; max-height: 568px; width: auto; height: auto; object-fit: contain; cursor: pointer;">`;
            } else if (mimeType.indexOf('application/pdf') >= 0) {
                contentHtml = `<object data="` + imageField.value + `" type="application/pdf" style="width: 100%; height: 100%;"></object>`;
            } else {
                let iconClass = this._getFileIconClass(mimeType);
                let fileName = imageField.fileName || '';
                contentHtml = `<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 0.5rem; padding: 1rem; text-align: center;">
                                    <i class="fal ` + iconClass + `" style="font-size: 4rem; color: #888;"></i>
                                    ` + (fileName !== '' ? `<div style="font-size: 0.85rem; color: #555; word-break: break-word; max-width: 100%;">` + fileName + `</div>` : ``) + `
                                </div>`;
            }

            template += `<div class="xp-carousel-img-frame" style="position: relative; flex: 1 1 auto; min-width: 0; min-height: 0; width: 100%; height: 100%; max-height: 568px; display: flex; align-items: center; justify-content: center; background: #f5f5f5; overflow: hidden;">
                            ` + contentHtml + `
                            <button type="button" class="btn btn-sm btn-light xp-carousel-expand" data-full-src="` + imageField.value + `" data-content-type="` + mimeType + `" style="position: absolute; top: 8px; right: 8px; z-index: 2; opacity: 0.9; padding: 0.25rem 0.5rem;"><i class="fal fa-expand"></i></button>
                            <button type="button" class="btn btn-sm btn-light xp-carousel-rotate-left" style="position: absolute; top: 8px; right: 80px; z-index: 2; opacity: 0.9; padding: 0;">
                                <span style="font-size: large; font-weight: bold;" class="pl-2 pr-2">↶</span>
                            </button>
                            <button type="button" class="btn btn-sm btn-light xp-carousel-rotate-right" style="position: absolute; top: 8px; right: 46px; z-index: 2; opacity: 0.9; padding: 0;">
                                <span style="font-size: large; font-weight: bold;" class="pl-2 pr-2">↷</span>
                            </button>
                        </div>`;

            template += `<div class="carousel-caption-options"><div class="carousel-inner-caption-options">`;

            for (let j = 0; j < this.itemActions.length; j++) {
                let itemAction = this.itemActions[j];

                let ml = 'ml-2';

                if (j == 0) {
                    ml = 'ml-auto';
                }

                let classPart = itemAction.attr.substr(itemAction.attr.indexOf('class="') + 'class="'.length);
                let actualClass = classPart.substr(0, classPart.indexOf('"'));
                itemAction.attr = itemAction.attr.replaceAll('class="' + actualClass + '"', '');
                itemAction.attr += 'class="' + actualClass + ' ' + ml + ' btn ' + 'list-action-button' + this.uniqueId + '"';

                let actionButtonIconTemplate = ``;

                if (itemAction.iconClass != null && itemAction.iconClass != '') {
                    actionButtonIconTemplate = `<i class="` + itemAction.iconClass + `"></i>`
                }

                template += `<button ` + itemAction.attr + ` action-type="element" item-id="` + items[i].pkVal + `" action-idx="` + j + `" title="` + itemAction.text + `" style="line-height: 0;">` + actionButtonIconTemplate + `<span>` + itemAction.text + `</span>` + `</button>`
            };

            template += '</div></div>';

            template += `<div class="carousel-caption">`;
            template += `<div class="carousel-inner-caption">`;
            let descriptionFields = this._getCarouselDescriptionFields(items[i]);

            for (let j = 0; j < descriptionFields.length; j++) {
                if (descriptionFields[j].value != null) {
                    if (j == 0) {
                        template += `<h5>` + descriptionFields[j].value + `</h5>`;
                    } else {
                        template += `<p>` + descriptionFields[j].value + `</p>`;
                    }
                }
            }

            template += `</div>`;
            template += `</div>`;
            template += `</div>`;
            template += `</div>`;
        }

        template += `</div>`;
        template += `</div>`;

        return template;
    }

    _getCarouselDescriptionFields(item) {
        let keys = Object.keys(item);

        let result = [];

        keys.forEach(key => {
            if (item[key].controlType == 0) {
                result.push(item[key]);
            }
        });

        return result;
    }

    _getCarouselImageField(item) {
        return item['fld_0'];
    }

    _getMasterColumnsWidth(tbl) {
        var result = 0;
        tbl.children("colgroup").find("col").each(function (idx, element) {
            result += parseInt($(element).outerWidth() || 0, 10);
        });

        return result;
    }

    _initGridControl() {
        $('#' + this.listControlId).parent().append(`<div id="` + this.modalWrapperUniqueId + `"></div>`);

        if (this.isPreview) {
            this.groupable = true;
        }

        const namesToDisable = ["Asociere notificare SNUAU 112 la Eveniment"];

        let options = {
            //Provizoriu Radu
            //autoBind: this.autoBind,
            autoBind: false,
            noRecords: true,
            messages: {
                noRecords: this.getGeneralResource('Grid_NoRecord')
            },
            groupable: this.groupable,
            sortable: this.getSortable(),
            pageable: this.getPageable(),
            columns: this.getColumns(!this.groupable),
            dataSource: this.getDataSource(),
            toolbar: this.toolbarActions,
            resizable: true,
            reorderable: true,
            pdf: {
                allPages: true,
                avoidLinks: true,
                paperSize: "A4",
                margin: { top: "2cm", left: "1cm", right: "1cm", bottom: "1cm" },
                landscape: true,
                repeatHeaders: true,
                scale: 0.8
            },
            scrollable: this.listType == 'TREE' ? true : !this.groupable,
            excel: {
                allPages: true,
                fileName: this.listName + '.xlsx',
                filterable: true
            },
            dataBound: (e) => {
                if (e.sender.dataSource.data().length > 0) {
                    this.applyListStyle('.k-grid-content-locked', 'border-bottom', 'none');
                }

                if (this.displayContext == 'modal' && this.parent == null) {
                    $('#' + this.containerId).closest('.k-window-content').data('kendoWindow').center();
                    if (this._checkMobile()) {
                        $('#' + this.listControlId).closest('.k-window').css({ top: "3.8rem", position: 'fixed' });
                    }
                }

                if (this.selectionType == 'multiple') {
                    if (this.pageType == 'SERVER_PAGING' || this.pageType == 'VIRTUAL') {
                        this.isPageChange = true;
                        let currentData = e.sender.dataSource.data();

                        currentData.forEach(item => {
                            if (this.selectedIds[item.id]) {
                                let idx = currentData.indexOf(item);
                                this._getGridControl().select('tr:eq(' + idx + ')');
                            }
                        });

                        this.isPageChange = false;
                    } else {
                        this.isPageChange = true;
                        let currentPage = e.sender.dataSource.page();
                        let pageSize = e.sender.dataSource.pageSize();
                        let currentData = e.sender.dataSource.data();

                        currentData.forEach(item => {
                            if (this.selectedIds[item.id]) {
                                let idx = currentData.indexOf(item);

                                if ((currentPage - 1) * pageSize <= idx && idx < ((currentPage - 1) * pageSize + pageSize)) {
                                    let actualIdx = idx - ((currentPage - 1) * pageSize);
                                    this._getGridControl().select('tr:eq(' + actualIdx + ')');
                                }
                            }
                        });

                        this.isPageChange = false;
                    }
                }

                if (this.listType == 'TREE' && $('#' + this.listControlId + ' .k-auto-scrollable').length > 0) {
                    let width = $('#' + this.listControlId + ' .k-auto-scrollable').css('width');

                    if (width != null && typeof width == 'string' && width.trim() != '' && $('#' + this.listControlId + ' .k-auto-scrollable').attr('width-applied') != 'yes') {
                        width = parseInt(width) - 15;
                        this.applyListStyle('.k-auto-scrollable', 'width', width + 'px');
                        $('#' + this.listControlId + ' .k-auto-scrollable').attr('width-applied', 'yes');
                    }
                }
            },
            excelExport: function (e) {
                var sheet = e.workbook.sheets[0];
                if (sheet.columns == null || sheet.rows == null) return;
                sheet.columns.forEach((col, colIdx) => {
                    var maxLen = 0;
                    sheet.rows.forEach(row => {
                        if (row.cells == null) return;
                        var cell = row.cells[colIdx];
                        if (cell != null && cell.value != null) {
                            var text = String(cell.value);
                            if (text.length > maxLen) maxLen = text.length;
                        }
                    });
                    col.width = Math.min(400, Math.max(60, maxLen * 7 + 12));
                    delete col.autoWidth;
                });
            },
            change: (e) => {
                if (!this.isPageChange) {
                    let currentSelection = Object.keys(e.sender._selectedIds);

                    let currentData = e.sender.dataSource.data();

                    currentData.forEach(item => {
                        let applySelection = false;
                        if (this.pageType == 'SERVER_PAGING' || this.pageType == 'VIRTUAL') {
                            applySelection = true;
                        } else {
                            let idx = currentData.indexOf(item);
                            let currentPage = e.sender.dataSource.page();
                            let pageSize = e.sender.dataSource.pageSize();

                            if ((currentPage - 1) * pageSize <= idx && idx < ((currentPage - 1) * pageSize + pageSize)) {
                                applySelection = true;
                            }
                        }

                        if (applySelection) {
                            let isSelected = currentSelection.filter(row => { return row == item.id }).length > 0;

                            if (isSelected) {
                                this.selectedIds[item.id] = true;
                            } else if (this.selectedIds[item.id]) {
                                delete this.selectedIds[item.id];
                            }
                        }
                    });
                }
            }
        };

        if (this.getPageable() != false) {
            options.pageSize = this.pageable.pageSize;
        }

        if (this.isPreview) {
            options.selectable = false;
        }

        if (this.listType == 'GRID') {
            this.listControl = $('#' + this.listControlId).kendoGrid(options);
        } else if (this.listType == 'TREE') {
            this.listControl = $('#' + this.listControlId).kendoTreeList(options);
        }

        this._addEventsForActionButtons();
        this._addEventsForRowClick();
        this._addEventsForTriggerTypeActions();
        this._addEventsForCsvInput();

        if (!this.hasActions) {
            this.applyListStyle('.k-grid-header', 'padding-right', 'unset', 'important');
        }
    }

    _addEventsForRowClick() {
        $('#' + this.listControlId + ' tbody').on('dblclick', 'tr', (evt) => {
            if ($(evt.target).closest('button, a').length > 0) {
                return;
            }
            let item = this._getGridControl().dataItem($(evt.currentTarget));
            if (item != null) {
                this.handleRowClick(item);
            }
        });
    }

    handleRowClick(item) {
        let editAction = this.itemActions != null ? this.itemActions.find(a => a.click == 'btnEditItem_onClick') : null;
        if (editAction != null) {
            this.handleEdit(item, editAction);
        }
    }

    _resolveActionTarget(itemAction) {
        if (itemAction.click != null) { return itemAction.click; }

        let attr = itemAction.attr;
        let actualUrl = '';

        if (attr != null && attr.length > 0 && attr.indexOf('Href = "') >= 0) {
            let urlPart = attr.substr(attr.indexOf('Href = "') + 'Href = "'.length);
            actualUrl = urlPart.substr(0, urlPart.indexOf('"'));
        }

        if (attr != null && attr.length > 0 && attr.indexOf('Href="') >= 0) {
            let urlPart = attr.substr(attr.indexOf('Href="') + 'Href="'.length);
            actualUrl = urlPart.substr(0, urlPart.indexOf('"'));
        }

        if (actualUrl.indexOf('/') == 0 && actualUrl.indexOf(this.rootUrl) == -1) {
            actualUrl = this.rootUrl + actualUrl.substring(1);
        }

        return actualUrl;
    }

    _addEventsForTriggerTypeActions() {
        if (this.itemActions == null) { return; }

        this.itemActions.forEach(itemAction => {
            let triggerType = itemAction.triggerType;
            if (triggerType == null || triggerType == 'DEFAULT') { return; }

            let actionTarget = this._resolveActionTarget(itemAction);

            if (triggerType == 'HOVER') {
                let hoverTimer = null;
                let hoverRow = null;

                $('#' + this.listControlId + ' tbody').on('mouseenter', 'tr', (evt) => {
                    let row = evt.currentTarget;
                    if (hoverTimer != null && hoverRow !== row) {
                        clearTimeout(hoverTimer);
                        hoverTimer = null;
                    }
                    hoverRow = row;
                    hoverTimer = setTimeout(() => {
                        let item = this._getGridControl().dataItem($(row));
                        if (item != null) {
                            itemAction.id = itemAction.name.replaceAll('custom_', '');
                            this.handleItemAction(item, actionTarget, itemAction);
                        }
                        hoverTimer = null;
                    }, 500);
                });

                $('#' + this.listControlId + ' tbody').on('mouseleave', 'tr', () => {
                    if (hoverTimer != null) {
                        clearTimeout(hoverTimer);
                        hoverTimer = null;
                    }
                    hoverRow = null;
                });
            } else {
                let eventName = triggerType == 'DBL_CLICK' ? 'dblclick' : 'click';

                $('#' + this.listControlId + ' tbody').on(eventName, 'tr', (evt) => {
                    if ($(evt.target).closest('button, a').length > 0) { return; }

                    let item = this._getGridControl().dataItem($(evt.currentTarget));
                    if (item != null) {
                        itemAction.id = itemAction.name.replaceAll('custom_', '');
                        this.handleItemAction(item, actionTarget, itemAction);
                    }
                });
            }
        });
    }

    _addEventsForActionButtons() {
        //CG: cautam doar in lista curenta - sublistele pe aceeasi lista au aceleasi nume de butoane si isi legau click-ul una pe butoanele celeilalte
        let listElement = $('#' + this.listControlId);

        this.toolbarActions.forEach(toolbarAction => {
            if (toolbarAction.name.indexOf('custom_') == 0) {
                let item = listElement.find('.k-grid-' + toolbarAction.name);

                if (item.length == 0) {
                    item = listElement.find('[data-command="' + toolbarAction.name + '"]');
                }

                if (toolbarAction.attr != null && toolbarAction.attr.length > 0 && toolbarAction.attr.indexOf('class="') >= 0) {
                    let classPart = toolbarAction.attr.substr(toolbarAction.attr.indexOf('class="') + 'class="'.length);
                    let actualClass = classPart.substr(0, classPart.indexOf('"'));
                    item.addClass(actualClass);
                }
            }
        });

        $($('#' + this.listControlId + ' .k-grid-toolbar .k-button')[0]).addClass('ml-auto');

        $('.list-action-button' + this.uniqueId).on('click', (evt) => {
            if (evt.currentTarget.getAttribute('action-type') == 'element') {
                let actionDescription = this.itemActions[evt.currentTarget.getAttribute('action-idx')];
                actionDescription.id = actionDescription.name.replaceAll('custom_', '');
                let pkVal = evt.currentTarget.getAttribute('item-id');
                let item = {};
                item[this.idField] = pkVal;

                this.handleItemAction(item, actionDescription.click, actionDescription);
            } else {
                let clickAction = $(evt.currentTarget).attr('btn-click');
                let actionId = $(evt.currentTarget).attr('action-id');

                if (this.listType == 'TREE') {
                    actionId = $(evt.currentTarget).attr('data-command').replaceAll('custom_', '');
                    let toolbarButton = this.toolbarActions.find(x => x.name == $(evt.currentTarget).attr('data-command'));
                    clickAction = toolbarButton.clickAction;
                }

                if (clickAction != null && clickAction.trim() != '') {

                    switch (clickAction) {
                        case 'btnJsItem_onClick':
                            {
                                evt.preventDefault();
                                this._handleGeneralJavascript(actionId);
                            }
                            break;
                        case 'btnFormWfItem_onClick': this._handleGeneralFormWf(actionId, $(evt.currentTarget));
                            break;
                        case 'btnImportExcelItem_onClick': this._handleGeneralImportExcel(actionId);
                            break;
                        case 'btnRefresh_onClick': this._handleRefresh();
                            break;
                        case 'btnReportItem_onClick': this._handleGeneralReport(actionId, $(evt.currentTarget));
                            break
                        default: break;
                    }
                } else {
                    var url = $(evt.currentTarget).attr('action-url');

                    if (url == null) {
                        let actionId = $(evt.currentTarget).attr('action-id');

                        if (actionId == null) {
                            let actionIdStr = $(evt.currentTarget).attr('data-command');

                            if (actionIdStr) {
                                actionId = actionIdStr.replaceAll('custom_', '');
                            }
                        }

                        if (actionId != null) {
                            let button = this.toolbarActions.find(x => x.name == 'custom_' + actionId);
                            let actualUrl;
                            if (button.attr != null && button.attr.length > 0 && button.attr.indexOf('action-url="') >= 0) {
                                let classPart = button.attr.substr(button.attr.indexOf('action-url="') + 'action-url="'.length);
                                actualUrl = classPart.substr(0, classPart.indexOf('"'));
                            }

                            if (actualUrl) {
                                url = actualUrl;
                            }
                        }
                    }

                    if (url != null && url != '') {
                        evt.preventDefault();

                        let isAlwaysModal = $(evt.currentTarget).attr('always-modal') == 'true';

                        if (this.listType == 'TREE') {
                            actionId = $(evt.currentTarget).attr('data-command').replaceAll('custom_', '');
                            let toolbarButton = this.toolbarActions.find(x => x.name == $(evt.currentTarget).attr('data-command'));


                            if (toolbarButton && toolbarButton.uiContent != null && toolbarButton.uiContent.trim() != '') {
                                let uiContent = JSON.parse(toolbarButton.uiContent);

                                if (uiContent != null) {
                                    isAlwaysModal = uiContent.isAlwaysModal;

                                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                                        $(evt.currentTarget).attr('modal-height', uiContent.modalHeight);
                                    }

                                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                                        $(evt.currentTarget).attr('modal-width', uiContent.modalWidth);
                                    }
                                }
                            }
                        }

                        if (this.parent != null) {
                            let _sublistMetadata = this.parent.getFieldMetadataByUniqueId(this.containerId);
                            if (_sublistMetadata != null && _sublistMetadata.CtlProps != null && _sublistMetadata.CtlProps.Target != null && _sublistMetadata.CtlProps.Target != '') {
                                if (this._openInTarget(url, _sublistMetadata.CtlProps.Target)) { return; }
                            }
                        }

                        if (((this.parent == null && this.displayContext != 'modal') || (this.parent != null && this.parent.context != 'modal')) && !isAlwaysModal) {
                            if (url.indexOf('EntityFormRuntime') > -1) {
                                $.pjax({ url: url, container: '#js-page-content', timeout: 10000, contentType: 'application/json' });
                            } else {
                                window.location.href = url;
                            }
                        } else {
                            let width = $(evt.currentTarget).attr('modal-width');
                            let height = $(evt.currentTarget).attr('modal-height');
                            this._initModal(url, width, height);
                        }
                    }
                }
            }
        });
    }

    _addEventsForCsvInput() {
        $('#' + this.csvInputId).on('change', () => {
            let reader = new FileReader();
            reader.onload = () => {
                let csvResult = reader.result;
                let csvData = this._csvToArray(csvResult);
                let uiUrl = rootURL + 'UILayout/GetUILayoutByIdForm?idForm=' + this.currentCsvCommand.formId;
                $.ajax({
                    url: uiUrl,
                    type: 'GET',
                    async: true,
                    dataType: 'json',
                    contentType: "application/json",
                    success: (uiLayout) => {
                        this._handleImport(uiLayout, csvData, this.currentCsvCommand.formId);
                    }
                });

                $('#' + this.csvInputId).val('');
            };

            reader.readAsText($('#' + this.csvInputId)[0].files[0]);
        });
    }

    _handleImport(layout, csvData, formId) {
        let fields = [];
        let csvFields = [];

        this._extractFields(layout, fields);

        for (let i = 0; i < csvData[0].length; i++) {
            let column = csvData[0][i];
            let field = fields.filter(row => { return row.EntityField.FieldName == column });

            if (field.length > 0) {
                field[0].csvIndex = i;
                csvFields.push(field[0]);
            }
        }

        if (csvFields.length == 0) {
            return;
        }

        let postData = [];

        for (let i = 1; i < csvData.length; i++) {
            let row = csvData[i];

            let postItem = {
                idForm: formId,
                pkVal: null,
                values: {}
            };

            for (let j = 0; j < csvFields.length; j++) {
                let csvValue = row[csvFields[j].csvIndex];
                postItem.values['fld_' + csvFields[j].Id] = csvValue;
            }

            postData.push(postItem);
        }

        let saveDataUrl = rootUrl + "EntityForm/SaveBulkData";

        showLoadingPanel();

        $.ajax({
            type: "POST",
            url: saveDataUrl,
            async: true,
            data: JSON.stringify(postData),
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                hideLoadingPanel();
                this._getGridControl().dataSource.read();
            },
            error: (e) => {
                hideLoadingPanel();
                toastr.error(e.responseText, this.getEntityFormResources('GetListError'));
            }
        });
    }

    _extractFields(item, fields) {
        if (item.TypeName == 'UIFieldControlDto') {
            fields.push(item);
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._extractFields(child, fields);
            });
        }
    }

    _csvToArray(strData, strDelimiter) {
        strDelimiter = (strDelimiter || ",");

        let commaOccurence = strData.split(',');
        let semicolonOccurence = strData.split(';');

        if (semicolonOccurence.length > commaOccurence.length) {
            strDelimiter = ';';
        }

        let objPattern = new RegExp(
            (
                // Delimiters.
                "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +

                // Quoted fields.
                "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

                // Standard fields.
                "([^\"\\" + strDelimiter + "\\r\\n]*))"
            ),
            "gi"
        );

        let arrData = [[]];

        let arrMatches = null;

        while (arrMatches = objPattern.exec(strData)) {
            let strMatchedDelimiter = arrMatches[1];

            if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
                arrData.push([]);

            }

            let strMatchedValue;

            if (arrMatches[2]) {
                strMatchedValue = arrMatches[2].replace(new RegExp("\"\"", "g"), "\"");

            } else {
                strMatchedValue = arrMatches[3];
            }

            arrData[arrData.length - 1].push(strMatchedValue);
        }

        return (arrData);
    }

    _handleRefresh() {
        this._getGridControl().dataSource.read();
    }

    _handleGeneralImportExcel(id) {
        let importCommand = JSON.parse(this.toolbarActions.filter(row => { return row.name == 'custom_' + id })[0].command);
        this.currentCsvCommand = importCommand;
        $('#' + this.csvInputId).click();
    }

    _handleGeneralJavascript(id) {
        if (window['btn_' + id + '_onClick'] != null) {
            window['btn_' + id + '_onClick']();
        }
        if (window['xp_list_action_' + id + '_onClick'] != null) {
            window['xp_list_action_' + id + '_onClick'](this);
        }
    }

    _handleGeneralFormWf(id, selector) {
        var url = this.rootUrl + 'UIAction/GetFormWFRun?idAction=' + id;

        let isAlwaysModal = selector.attr('always-modal') == 'true';

        if (((this.parent == null && this.displayContext != 'modal') || (this.parent != null && this.parent.context != 'modal')) && !isAlwaysModal) {
            $.pjax({ url: url, container: '#js-page-content', timeout: 10000 })
        } else {
            let width = selector.attr('modal-width');
            let height = selector.attr('modal-height');
            this._initModal(url, width, height);
        }
    }

    _handleGeneralReport(id, selector) {
        let url = selector.attr('action-url');
        window.open(url + '&context=modal', '_blank');
    }

    _generateUUID() {
        var d = new Date().getTime();
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        }).replaceAll('-', '');
    }

    _checkMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    _initModal(url, width, height, postParam) {
        if (url.indexOf('?') >= 0) {
            url += '&context=modal&parentGuid=' + this.uniqueControlId;
        } else {
            url += '?context=modal&parentGuid=' + this.uniqueControlId;
        }

        if (this.parent != null) {
            $('#' + this.parent.uniqueModalId)[0].innerHTML = `<div class="p-1 pt-2 pb-2" id="` + this.modalInner + `"></div>`;
        } else {
            $('#' + this.modalWrapperUniqueId)[0].innerHTML = `<div class="p-1 pt-2 pb-2" id="` + this.modalInner + `"></div>`;
        }

        var content = {
            url: url
        };
        if (postParam != null) {
            content = null;
        }

        let modalOptions = {
            draggable: true,
            resizable: true,
            width: width != null && width != '' ? width : "90%",
            height: height != null && height != '' ? height : "auto",
            maxHeight: (window.innerHeight * 0.9).toFixed(),
            title: '',
            modal: $('.map-centered').length == 0,
            content: null,
            actions: ["Minimize", "Maximize", "Close"],
            close: () => { this.closeModal(); }
        };

        if (this._checkMobile()) {
            modalOptions.height = 'auto';
            modalOptions.maxHeight = 'calc(100% - 3.8rem)';
            modalOptions.width = '100%';
        }

        $('#' + this.modalInner).kendoWindow(modalOptions);
        if ($('body')[0].classList.contains('mod-skin-dark')) {
            $('.k-window').addClass('mod-skin-dark');
        }
        if (this._checkMobile()) {
            // reaplicam full-screen-ul dupa ce continutul remote este incarcat (Kendo recalculeaza layout-ul)
            $('#' + this.modalInner).data("kendoWindow").bind("refresh", () => {
                this._stretchModalFullScreen($('#' + this.modalInner).data("kendoWindow"));
            });
        }
        if (postParam != null) {
            var content = {};
            content.url = url;
            content.type = "POST";
            content.data = postParam;
            content.contentType = "application/json";
            $('#' + this.modalInner).data("kendoWindow").refresh(content);
        } else {
            var content = {};
            content.url = url;
            content.type = "GET";
            content.contentType = "application/json";
            $('#' + this.modalInner).data("kendoWindow").refresh(content);
        }


        this.centerModal();
        if (this.displayContext == 'modal' || (this.parent != null && this.parent.context == 'modal')) {
            $('#' + this.listControlId).closest('.k-window').hide();
        }
    }

    centerModal() {
        let kendoWindow = $('#' + this.modalInner).data("kendoWindow");
        if (kendoWindow) {
            kendoWindow.center();

            if (this._checkMobile()) {
                // pe mobil fortam fereastra sa ocupe tot ecranul sub header (3.8rem)
                this._stretchModalFullScreen(kendoWindow);
            }
        }
    }

    // Kendo Window cu height:'auto' se intinde doar dupa continut si .center() o pozitioneaza
    // gresit la width:100% (din cauza border-ului wrapper-ului). Pe mobil ancoram explicit
    // wrapper-ul la viewport ca sa umple toata pagina sub header.
    _stretchModalFullScreen(kendoWindow) {
        if (kendoWindow == null) {
            return;
        }

        kendoWindow.wrapper.css({
            position: 'fixed',
            top: '3.8rem',
            left: '0',
            right: '0',
            width: '100%',
            height: 'calc(100% - 3.8rem)',
            'max-height': 'none',
            margin: '0'
        });

        // continutul ferestrei trebuie sa umple wrapper-ul, mai putin bara de titlu
        let titlebarHeight = kendoWindow.wrapper.children('.k-window-titlebar').outerHeight() || 0;
        kendoWindow.wrapper.children('.k-window-content').css({
            height: 'calc(100% - ' + titlebarHeight + 'px)',
            'max-height': 'none'
        });
    }

    closeModal() {
        $('#' + this.modalInner).data("kendoWindow").destroy();

        if (this.displayContext == 'modal' || (this.parent != null && this.parent.context == 'modal')) {
            $('#' + this.listControlId).closest('.k-window').show();
            $('#' + this.listControlId).closest('.k-window').css({ top: "3.8rem", position: 'fixed' });
        }

        if (this.listType == 'CAROUSEL') {
            $('#' + this.listControlId)[0].innerHTML = '';
            this._initCarouselControl();
        } else {
            this._getGridControl().dataSource.read();
        }
    }

    notifyFilters(filters) {
        var keys = Object.keys(filters.values);

        this.filters = {};

        keys.forEach(key => {
            if (key.indexOf('fld_') == 0 && filters.values[key] != null) {
                this.filters[key] = filters.values[key];
            }
        });

        if (this.pageType == 'CLIENT_PAGING') {
            this._getGridControl().dataSource.read();
        } else {
            this._getGridControl().pager.page(1);
        }
    }

    initStructure() {
        let structure = ``;

        if (this.parent == null) {
            structure = `<div id="` + this.listControlTitleId + `" style="margin-left: 1rem; margin-top: 1rem;"><p style="font-size: 1.1rem; font-weight: 400; margin-bottom: 0;">` + this.listName + `</p></div><div id="` + this.filterControlId + `" class="xp-form-container"></div><div id="` + this.listControlId + `" style="background-color: transparent;` + (this.listType == 'CAROUSEL' ? (this.parent == null ? ` height: 600px;` : `height: calc(100% - 2rem);`) : ``) + `"` + (this.listType == 'CAROUSEL' ? ` class="p-3"` : ``) + `></div><input id="` + this.csvInputId + `" class="form-control" accept=".csv" required="" type="file" style="display: none;">`;
        } else {
            structure = `<div id="` + this.filterControlId + `" class="xp-form-container"></div><div id="` + this.listControlId + `" style="background-color: transparent;` + (this.listType == 'CAROUSEL' ? (this.parent == null ? ` height: 600px;` : `height: calc(100% - 2rem);`) : ``) + `"` + (this.listType == 'CAROUSEL' ? ` class="p-3"` : ``) + `></div><input id="` + this.csvInputId + `" class="form-control" accept=".csv" required="" type="file" style="display: none;">`;
        }

        $('#' + this.containerId).append(structure);
    }

    getDataSource() {
        let dataSource = null;

        if (this.isPreview) {
            if (this.listType == 'GRID') {
                dataSource = new kendo.data.DataSource(this.getPreviewDataSourceOptions());
            } else if (this.listType == 'TREE') {
                dataSource = new kendo.data.TreeListDataSource(this.getPreviewDataSourceOptions());
            }
        } else {
            if (this.listType == 'GRID') {
                dataSource = new kendo.data.DataSource(this.getRuntimeDataSourceOptions());
            } else if (this.listType == 'TREE') {
                dataSource = new kendo.data.TreeListDataSource(this.getRuntimeDataSourceOptions());
            }
        }

        return dataSource;
    }

    getPreviewDataSourceOptions() {
        let modelFields = {};

        this.fields.forEach(field => {
            if (field.fieldDataType == 'DATE' || field.fieldDataType == 'TIMESTAMP') {
                modelFields[field.id] = {
                    type: 'date'
                };
            } else if (field.fieldDataType == 'NUMERIC' || field.fieldDataType == 'INTEGER') {
                modelFields[field.id] = {
                    type: 'number'
                };
            } else {
                modelFields[field.id] = {
                    type: 'string'
                };
            }
        });

        let options = {
            schema:
            {
                data: "Data",
                total: "Total",
                model: {
                    id: (this.idField == null ? null : this.idField.toLowerCase()),
                    fields: modelFields
                }
            },
            data: []/*this.getPreviewData(1)*/,
            serverPaging: this.pageType == 'SERVER_PAGING' || this.pageType == 'VIRTUAL',
            serverSorting: this.pageType == 'SERVER_PAGING' || this.pageType == 'VIRTUAL',
            pageable: this.pageType == 'SERVER_PAGING' || this.pageType == 'CLIENT_PAGING',
            sortable: {
                mode: this.sortType
            }
        };

        if (this.getPageable() != false) {
            options.pageSize = this.pageable.pageSize;
        }

        return options;
    }

    getPreviewData(count) {
        if (this.fields.length == 0) {
            return {
                Data: [],
                Total: 0
            };
        }

        let result = {
            Data: [],
            Total: count
        };

        for (var a = 0; a < count; a++) {
            let data = {};

            for (var i = 0; i < this.fields.length; i++) {
                switch (this.fields[i].fieldDataType) {
                    case 'STRING': data[this.fields[i].id] = 'Valoare';
                        break;
                    case 'NUMERIC': data[this.fields[i].id] = 1.0;
                        break;
                    case 'INTEGER': {
                        switch (this.fields[i].fieldDataSubType) {
                            case 'FOREIGN_KEY': data[this.fields[i].id + '_fktext'] = 'Valoare Nomenclator';
                                break;
                            default: data[this.fields[i].id] = 1;
                                break;
                        }
                    }
                        break;
                    case 'DATE': data[this.fields[i].id] = '04.04.2023';
                        break;
                    case 'TIMESTAMP': data[this.fields[i].id] = '04.04.2023 12:00:00';
                        break;
                    case 'GEOMETRY': data[this.fields[i].id] = 'N/A';
                        break;
                    case 'BYTEA': data[this.fields[i].id] = 'N/A';
                        break;
                    case 'BOOLEAN': data[this.fields[i].id] = 'True';
                        break;
                    case 'BoolInt': data[this.fields[i].id] = 1;
                        break;
                }
            }

            data.xp_allow_del = '1';
            data.xp_allow_edit = '1';

            result.Data.push(data);
        }

        return result;
    }

    getRuntimeDataSourceOptions() {
        let modelFields = {};
        let group = [];

        this.fields.forEach(field => {
            if (field.fieldDataType == 'DATE' || field.fieldDataType == 'TIMESTAMP') {
                modelFields[field.id] = {
                    type: 'date'
                };
            } else if (field.fieldDataType == 'NUMERIC' || field.fieldDataType == 'INTEGER') {
                modelFields[field.id] = {
                    type: 'number'
                };
            } else {
                modelFields[field.id] = {
                    type: 'string'
                };
            }
        });

        if (Object.keys(modelFields).length == 0) {
            return [];
        }

        let dataSourceUrl = '';

        let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));

        if (listFilterHolder[this.uid] != null && Object.keys(listFilterHolder[this.uid]).length > 0) {
            this.filters = {};
            var keys = Object.keys(listFilterHolder[this.uid].values);

            keys.forEach(key => {
                if (key.indexOf('fld_') == 0 && listFilterHolder[this.uid].values[key] != null) {
                    this.filters[key] = listFilterHolder[this.uid].values[key];
                }
            });
        }

        if (this.getDataUrl == null || this.getDataUrl.trim() == '') {
            if (this.parent != null) {
                dataSourceUrl = 'EntityList/GetSubListData';
            } else {
                dataSourceUrl = 'EntityList/GetData';
            }
        } else {
            dataSourceUrl = this.getDataUrl.substring(1);
        }

        var read = {};
        read.dataType = 'json';
        read.url = this.rootUrl + dataSourceUrl;
        if (this.getDataPostParam == null) {
            read.type = "GET";
            read.contentType = 'application/json';
        }
        else {
            read.type = "POST";
        }

        let options = {
            schema:
            {
                data: "Data",
                total: "Total",
                model: {
                    id: (this.idField == null ? null : this.idField.toLowerCase()),
                    fields: modelFields
                }
            },
            transport: {
                read: read,
                parameterMap: (data, type) => {
                    if (type == 'read') {
                        if (this.parent != null) {
                            data.idUISubList = this.uiLayoutId;
                            data.pkVal = this.parentPkVal;
                            var parentValues = {
                                formId: {
                                    value: this.parent.formId * 1,
                                    type: 'INTEGER'
                                },
                                objectId: {
                                    value: this.parent.objectId,
                                    type: 'STRING'
                                }
                            }

                            let listContainerMetadata = this.parent.getFieldMetadataByUniqueId(this.containerId);

                            if (listContainerMetadata.DependsOnGuids != null && listContainerMetadata.DependsOnGuids.length > 0) {
                                listContainerMetadata.DependsOnGuids.forEach(depends => {
                                    let dependant = this.parent._getItemByGuid(depends, [this.parent.metadata]);
                                    let value = this.parent._getItemValueByGuid(depends, true);
                                    var tagName = dependant.Name;
                                    var tagNameFld = "fld_" + dependant.Name;
                                    var dataType = dependant.DataType;

                                    if (dependant.EntityField) {
                                        tagName = dependant.EntityField.FieldName;
                                        dataType = dependant.EntityField.DataType;
                                    }

                                    if (listContainerMetadata.SqlWhere != null && listContainerMetadata.SqlWhere != '' && (listContainerMetadata.SqlWhere.indexOf(tagName) >= 0 || listContainerMetadata.SqlWhere.indexOf(tagNameFld) >= 0)) {
                                        parentValues["fld_" + dependant.Id] = {
                                            value: value,
                                            type: dataType
                                        };
                                    }
                                });
                            }

                            data.parentValues = JSON.stringify(parentValues);
                        } else {
                            data.id = this.listId;
                        }

                        data.filters = JSON.stringify(this.filters);
                        if (data.sort != null && data.sort.length > 0) {
                            let orderBy = {};

                            for (let i = 0; i < data.sort.length; i++) {
                                for (let j = 0; j < this.fields.length; j++) {
                                    let field = this.fields[j];

                                    if (data.sort[i].field == field.id) {
                                        orderBy[field.id.replaceAll(this.fieldPrefix, '').replaceAll('_', '-')] = data.sort[i].dir;
                                    }
                                    else if (field.fieldDataSubType == 'FOREIGN_KEY' && data.sort[i].field == field.id + "_fktext") {
                                        orderBy[field.id.replaceAll(this.fieldPrefix, '').replaceAll('_', '-')] = data.sort[i].dir;
                                    }
                                }
                            }

                            data.orderby = JSON.stringify(orderBy);
                        }

                        if (this.idExtConn != null) {
                            data.idExtConn = this.idExtConn;
                        }

                        if (this.getDataPostParam != null) {
                            data.postData = JSON.parse(this.getDataPostParam);
                        }
                        return data;
                    } else {
                        return data;
                    }
                }
            },
            serverPaging: this.pageType == 'SERVER_PAGING' || this.pageType == 'VIRTUAL',
            serverSorting: this.pageType == 'SERVER_PAGING' || this.pageType == 'VIRTUAL',
            pageable: this.pageType == 'SERVER_PAGING' || this.pageType == 'CLIENT_PAGING',
            sortable: {
                mode: this.sortType
            }
        };

        if (this.getPageable() != false) {
            options.pageSize = this.pageable.pageSize;
        }

        return options;
    }

    getToolbarButtons(buttons) {
        let result = [];

        if (buttons != null && buttons.length > 0) {
            for (let i = 0; i < buttons.length; i++) {
                let button = buttons[i];

                if (button.attr != null && button.attr.length > 0 && button.attr.indexOf('DevExRpt') >= 0) {
                    let actualUrl = '';

                    if (button.attr != null && button.attr.length > 0 && button.attr.indexOf('Href = "') >= 0) {
                        let urlPart = button.attr.substr(button.attr.indexOf('Href = "') + 'Href = "'.length);
                        actualUrl = urlPart.substr(0, urlPart.lastIndexOf('"'));
                        button.attr = button.attr.replaceAll('Href = "' + actualUrl + '"', 'Href = "#"');
                    }

                    if (button.attr != null && button.attr.length > 0 && button.attr.indexOf('Href="') >= 0) {
                        let urlPart = button.attr.substr(button.attr.indexOf('Href="') + 'Href="'.length);
                        actualUrl = urlPart.substr(0, urlPart.lastIndexOf('"'));
                        button.attr = button.attr.replaceAll('Href="' + actualUrl + '"', 'Href="#"');
                    }

                    button.attr += ' action-url="' + encodeURI(actualUrl) + '"';

                    if (button.attr != null && button.attr.length > 0 && button.attr.indexOf('class="') >= 0) {
                        let classPart = button.attr.substr(button.attr.indexOf('class="') + 'class="'.length);
                        let actualClass = classPart.substr(0, classPart.indexOf('"'));
                        button.attr = button.attr.replaceAll('class="' + actualClass + '"', '');
                        button.attr += 'class="' + actualClass + ' list-action-button' + this.uniqueId + '"';
                    } else {
                        if (button.attr == null) {
                            button.attr = '';
                        }
                        button.attr += 'class="list-action-button' + this.uniqueId + '"';
                    }

                    if (button.click != null && button.click.trim() != '') {
                        button.attr += ' btn-click="' + button.click + '" action-id="' + button.name.replaceAll('custom_', '') + '"';
                    }

                    if (button.uiContent != null && button.uiContent.trim() != null) {
                        let uiContent = JSON.parse(button.uiContent);

                        if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                            button.attr += ' modal-height="' + uiContent.modalHeight + '"';
                        }

                        if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                            button.attr += ' modal-width="' + uiContent.modalWidth + '"';
                        }

                        if (uiContent.isAlwaysModal != null) {
                            button.attr += ' always-modal="' + uiContent.isAlwaysModal + '"';
                        } else {
                            button.attr += ' always-modal="false"';
                        }
                    } else {
                        button.attr += ' always-modal="false"';
                    }
                } else {
                    if (button.attr != null && button.attr.length > 0 && button.attr.indexOf('Href = "') >= 0) {
                        let urlPart = button.attr.substr(button.attr.indexOf('Href = "') + 'Href = "'.length);
                        let actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

                        button.attr = button.attr.replaceAll('Href = "' + actualUrl + '"', 'Href = "#"');

                        actualUrl = this.replaceUrlTokens(actualUrl);

                        if (actualUrl.indexOf('/') == 0 && actualUrl.indexOf(this.rootUrl) == -1) {
                            actualUrl = this.rootUrl + actualUrl.substr(1);
                        }

                        button.attr += ' action-url="' + actualUrl + '"';
                    }

                    if (button.attr != null && button.attr.length > 0 && button.attr.indexOf('Href="') >= 0) {
                        let urlPart = button.attr.substr(button.attr.indexOf('Href="') + 'Href="'.length);
                        let actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

                        button.attr = button.attr.replaceAll('Href="' + actualUrl + '"', 'Href="#"');

                        actualUrl = this.replaceUrlTokens(actualUrl);

                        if (actualUrl.indexOf('/') == 0 && actualUrl.indexOf(this.rootUrl) == -1) {
                            if (this.rootUrl.endsWith('/')) {
                                actualUrl = this.rootUrl + actualUrl.substr(1);
                            } else {
                                actualUrl = this.rootUrl + actualUrl;
                            }
                        }

                        button.attr += ' action-url="' + actualUrl + '"';
                    }

                    if (button.attr != null && button.attr.length > 0 && button.attr.indexOf('class="') >= 0) {
                        let classPart = button.attr.substr(button.attr.indexOf('class="') + 'class="'.length);
                        let actualClass = classPart.substr(0, classPart.indexOf('"'));
                        button.attr = button.attr.replaceAll('class="' + actualClass + '"', '');
                        button.attr += ' class="' + actualClass + ' list-action-button' + this.uniqueId + '"';
                    } else {
                        if (button.attr == null) {
                            button.attr = '';
                        }
                        button.attr += ' class="list-action-button' + this.uniqueId + '"';
                    }

                    if (button.click != null && button.click.trim() != '') {
                        button.attr += ' btn-click="' + button.click + '" action-id="' + button.name.replaceAll('custom_', '') + '"';

                        if (this.listType != 'TREE') {
                            button.click = null;
                        } else {
                            button.clickAction = button.click;
                            button.click = null;
                        }
                    } else {
                        button.attr += ' action-id="' + button.name.replaceAll('custom_', '') + '"';
                    }

                    if (button.uiContent != null && button.uiContent.trim() != null) {
                        let uiContent = JSON.parse(button.uiContent);

                        if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                            button.attr += ' modal-height="' + uiContent.modalHeight + '"';
                        }

                        if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                            button.attr += ' modal-width="' + uiContent.modalWidth + '"';
                        }

                        if (uiContent.isAlwaysModal != null) {
                            button.attr += ' always-modal="' + uiContent.isAlwaysModal + '"';
                        } else {
                            button.attr += ' always-modal="false"';
                        }
                    } else {
                        button.attr += ' always-modal="false"';
                    }
                }

                result.push(button);
            }
        }

        return result;
    }

    handleButtonClick(item) {

    }

    getColumns(useStickyColumns) {
        let result = [];

        if (this.selectionType == 'multiple') {
            result.push({
                selectable: true,
                width: '3rem',
                attributes: {
                    minWidth: '3rem',
                    canBeHidden: 'false',
                    "class": "checkbox-align",
                    style: 'text-align: center'
                },
                headerAttributes: {
                    "class": "checkbox-align",
                    style: 'text-align: center; justify-content: center'
                }
            });
        }
        
        this.fields.forEach(configField => {
            if (!configField.hidden) {
                let htmlAttributtes = configField.htmlAttributes;

                if (htmlAttributtes == null) {
                    htmlAttributtes = {};
                }

                let column = {
                    field: configField.id,
                    title: configField.name,
                    width: configField.width,
                    attributes: htmlAttributtes,
                    sortable: configField.sortable == true,
                    groupable: configField.groupable == true,
                    resizable: true
                };

                if (configField.fieldDataSubType == 'FOREIGN_KEY') {
                    column.field = configField.id + '_fktext';
                }

                if (configField.templateJs != null) {
                    if (configField.templateJs.startsWith("function")) {
                        column.template = eval("(" + configField.templateJs + ")");
                    }
                    else {
                        column.template = new Function("dataItem", configField.templateJs);
                    }                    
                }
                if (configField.templateHtml != null) {
                    column.template = (dataItem) => {
                        var text = configField.templateHtml;
                        text = text.replaceAll('{ROOT_URL}', this.rootUrl);
                        return kendo.template(text);
                    };
                }
                else if ((configField.fieldDataSubType == 'FILE' && configField.controlType == 1) || (configField.fieldDataType == 'BYTEA' && configField.controlType == 1)) {
                    column.template = (dataItem) => {
                        if (this.isPreview) {
                            return '<img class="d-block" src="' + (this.rootUrl + 'img/card-backgrounds/cover-1-lg.png') + '" height="50" width="100" onerror="this.src=\'' + this.rootUrl + 'img/fnf.png\'' + '"></img>';
                        } else {
                            let idEntityField = configField.fieldIdEntityField;
                            let pkVal = dataItem[this.idField];
                            return '<img class="d-block" src="' + (dataItem[configField.id] != null ? (this.rootUrl + 'Entity/GetFileContent?idEntityField=' + idEntityField + '&pkVal=' + pkVal) : null) + '" height="50" width="100" onerror="this.src=\'' + this.rootUrl + 'img/fnf.png\'' + '"></img>';
                        }
                    };
                } else if ((configField.fieldDataSubType == 'FILE' && configField.controlType == 0) || (configField.fieldDataType == 'BYTEA' && configField.controlType == 0) || configField.fieldDataSubType == 'URL') {
                    column.template = (dataItem) => {
                        let url = '';

                        if (configField.fieldDataSubType == 'URL') {
                            if (dataItem[configField.id] == null || dataItem[configField.id] == '') {
                                url = '#';
                            } else {
                                url = dataItem[configField.id];
                            }
                        } else {
                            if (dataItem[configField.id] == null || dataItem[configField.id] == '' || dataItem[configField.id] == 'false') {
                                return '';
                            }
                            else {
                                let idEntityField = configField.fieldIdEntityField;
                                let pkVal = dataItem[this.idField];
                                url = dataItem[configField.id] != null ? (this.rootUrl + 'Entity/GetFileContent?idEntityField=' + idEntityField + '&pkVal=' + pkVal) : '#';
                            }

                        }

                        if (configField.format != null && configField.format.trim() != '' && configField.format.indexOf('{URL}') >= 0) {
                            return configField.format.replaceAll('{URL}', url);
                        } else {
                            return this.getLayoutResource('ListUrlTemplate').replaceAll('{URL}', url);
                        }
                    };
                } else if (configField.format != null && configField.format.trim() != '') {
                    column.format = configField.format;
                } else if (configField.boolFormat != null && configField.boolFormat.trim() != '') {
                    column.template = (dataItem) => {
                        let val = this._parseBooleanCommandResult(dataItem[configField.id]);

                        let boolTuples = configField.boolFormat.split(':');

                        if (boolTuples.length == 2) {
                            //avem numai false si true
                        }
                        else if (boolTuples.length == 3) {
                            //avem false, true si null
                        }
                        else {
                            boolTuples = [this.getGeneralResource('BOOL_NO'), this.getGeneralResource('BOOL_YES'), this.getGeneralResource('BOOL_NULL')];
                        }

                        if (val === null) {
                            if (boolTuples.length == 3) {
                                return boolTuples[2];
                            }
                            else {
                                return boolTuples[0];
                            }
                        }
                        else if (val === false) {
                            return boolTuples[0];
                        }
                        else {
                            return boolTuples[1];
                        }
                    };
                }

                if (column.template == null && configField.fieldDataType != 'DATE' && configField.fieldDataType != 'TIMESTAMP') {
                    column.template = (dataItem) => {
                        if (dataItem[configField.id] == null || dataItem[configField.id] === '') {
                            return '<div style="height: calc(1.24rem);"></div>';
                        } else {
                            if (configField.fieldDataSubType == 'FOREIGN_KEY') {
                                return dataItem[configField.id + '_fktext'];
                            } else if (configField.format != null && configField.format != '') {
                                const format = configField.format;
                                const kendoFormat = format.replace("{0:", "").replace("}", "");

                                return kendo.toString(dataItem[configField.id], kendoFormat);
                            } else {
                                return dataItem[configField.id];
                            }
                        }
                    }
                }

                result.push(column);
            }
        });

        let actionColumn = this.getActionColumn(useStickyColumns);

        if (actionColumn != null) {
            result.push(actionColumn);
        } else {
            this.hasActions = false;
        }

        return result;
    }

    _parseBooleanCommandResult(item) {
        if (item == null) {
            return null;
        }

        if (item == 1 || item == '1' || item == true || item == 'true' || item == 'True') {
            return true;
        }

        if (item === 0 || item === '0' || item === false || item === 'false' || item === 'False') {
            return false;
        }

        let keys = Object.keys(item);

        if (keys.length > 0) {
            let value = item[keys[0]];

            if (value === 1 || value === '1' || value === true || value === 'true' || value === 'True') {
                return true;
            }

            if (value === 0 || value === '0' || value === false || value === 'false' || value === 'False') {
                return false;
            }
        }

        return null;
    }

    handleShowInMapVisibility(item, idEntity, idEntityField) {
        //daca este camp de pe alta entitate nu putem face aici logica de vizibilitate (cel putin nu pe moment)
        if (idEntity != null) {
            return true;
        }
        let contextFields = this.fields.filter(row => { return row.fieldIdEntityField == idEntityField });

        if (contextFields.length > 0) {
            return this._parseBooleanCommandResult(item[contextFields[0].id]);
        }

        return true;
    }

    handleItemAction(item, actionType, action) {
        switch (actionType) {
            case 'btnEditItem_onClick': this.handleEdit(item, action);
                break;
            case 'btnViewItem_onClick': this.handleView(item, action);
                break;
            case 'btnReportItem_onClick': this.handleReport(item, action);
                break;
            case 'btnDelItem_onClick': this.handleDelete(item);
                break;
            case 'btnShowMapItem_onClick': this.handleShowMapItem(item, action);
                break;
            case 'btnJsItem_onClick': this.handleJsItem(item, action);
                break;
            case 'btnFormWfItem_onClick': this._handleItemFormWf(item, action);
                break;
            case 'btnEditItem_visible': return item.xp_allow_edit;
                break;
            case 'btnDelItem_visible': return item.xp_allow_del;
                break;
            case 'btnViewItem_visible': return true;
                break;
            case 'btnShowMapItem_visible': return true;
                break;
            case 'btnJsItem_visible': return true;
                break;
            case 'btnFormWfItem_visible': return true;
                break;
            default: return this.handleDefaultAction(item, actionType, action);
                break;
        }
    }

    handleDefaultAction(item, actionType, action) {
        this.fields.forEach(field => {
            if (actionType.indexOf('{' + field.fieldName + '}') > 0) {
                actionType = actionType.replaceAll('{' + field.fieldName + '}', item[field.id]);
            }
        });

        let uiContent = {};

        if (action.uiContent != null && action.uiContent.trim() != '') {
            uiContent = JSON.parse(action.uiContent);
        }

        let isAlwaysModal = uiContent.isAlwaysModal != null ? uiContent.isAlwaysModal : false;

        if (((this.parent == null && this.displayContext != 'modal') || (this.parent != null && this.parent.context != 'modal')) && !isAlwaysModal) {
            $.pjax({ url: actionType, container: '#js-page-content', timeout: 10000 })
        } else {
            let width = null;
            let height = null;

            if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != null) {
                width = uiContent.modalWidth;
            }

            if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != null) {
                height = uiContent.modalHeight;
            }

            this._initModal(actionType, width, height);
        }
    }

    handleShowMapItem(item, action) {
        //let idPart = action.attr.replaceAll('IdFieldTarget="', '');
        //let geomFieldId = idPart.substr(0, idPart.indexOf('"'));

        var text = 'IdFieldTarget="';
        var startIndex = action.attr.indexOf(text);
        startIndex += text.length;
        var endIndex = action.attr.indexOf('"', startIndex);
        let geomFieldId = action.attr.substr(startIndex, endIndex - startIndex);


        //deocamdata nu se foloseste, deoarece ne este suficient doar Id-ul campului geometrie
        var text = 'IdEntityTarget="';
        var startIndex = action.attr.indexOf(text);
        startIndex += text.length;
        var endIndex = action.attr.indexOf('"', startIndex);
        let entityTargetId = action.attr.substr(startIndex, endIndex - startIndex);

        if (window.mapCtrl != null) {
            let layerSettings = window.mapCtrl.config.layersSettings.filter(row => { return row.geometryFieldId == geomFieldId })[0];

            let mapLayerId = layerSettings.id;
            let featureId = item[this.idField];

            let scale = null;

            if (layerSettings.geometryType == 'POINT') {
                scale = 500;
            }

            if (legendControl != null) {
                legendControl.toggleSelection(mapLayerId, true);
            }

            window.mapCtrl.showFeature(mapLayerId, featureId, scale, () => { }, (evt) => {
                if (typeof evt == 'object' && evt.message != null) {
                    swal.fire({ title: 'Atentie', html: this.getLayoutResource(evt.message) });
                } else if (typeof evt == 'string') {
                    swal.fire({ title: 'Atentie', html: this.getLayoutResource(evt) });
                }
            });
        } else {
            let maps = Array.from(document.getElementsByClassName('xp-map'));

            maps.forEach(map => {
                let mapControl = map.mapControl;

                let layerSettings = mapControl.layerSettingsHandler.getLayerSettingsByField(geomFieldId, this.idExtConn, item[this.idField], false);

                let featureId = item[this.idField];
                if (layerSettings == null) {
                    layerSettings = mapControl.layerSettingsHandler.getLayerSettingsByField(geomFieldId, this.idExtConn, null, false);
                    featureId = null;
                }

                let mapLayerId = layerSettings.Id;

                let scale = null;

                if (layerSettings.Entity.GeometryFieldType == 'POINT') {
                    scale = 500;
                }

                mapControl.generalActionHandler.generalActionControls.legendControl.toggleSelection(mapLayerId, true);

                mapControl.showFeature(mapLayerId, featureId, scale, () => { }, (evt) => {
                    if (typeof evt == 'object' && evt.message != null) {
                        swal.fire({ title: 'Atentie', html: this.getLayoutResource(evt.message), allowOutsideClick: false });
                    } else if (typeof evt == 'string') {
                        swal.fire({ title: 'Atentie', html: this.getLayoutResource(evt), allowOutsideClick: false });
                    }
                });
            });
        }
    }

    handleJsItem(item, action) {
        let dataItem = {};

        this.fields.forEach(field => {
            dataItem[field.fieldName] = this._cloneItem(field);
            dataItem[field.fieldName].value = item[field.id];
        });
        //SM: 27.05.2026 - pun la dispozitie si campul cheie primara si campurile de permisiuni la executia de js
        dataItem["xp_pk_val"] = {};
        dataItem["xp_pk_val"].value = item.id;
        dataItem["xp_allow_edit"] = {};
        dataItem["xp_allow_edit"].value = item.xp_allow_edit;
        dataItem["xp_allow_del"] = {};
        dataItem["xp_allow_del"].value = item.xp_allow_del;

        if (window['btn_' + action.id + '_onClick'] != null) {
            window['btn_' + action.id + '_onClick'](dataItem);
        }
        if (window['xp_list_action_' + action.id + '_onClick'] != null) {
            window['xp_list_action_' + action.id + '_onClick'](this, dataItem);
        }
    }

    convertFieldToItem(item) {
        let dataItem = {};

        this.fields.forEach(field => {
            dataItem[field.fieldName] = this._cloneItem(field);
            dataItem[field.fieldName].value = item[field.id];
            dataItem.rowId = item.uid;
        });

        return dataItem;
    }

    getURLParams(url) {
        var params = [];

        while (url.indexOf("{") > -1 && url.indexOf("}") > -1) {

            var param = url.substring(url.indexOf("{"), url.indexOf("}") + 1);
            while (url.indexOf(param) > -1) {
                url = url.replace(param, "")
            }

            params.push(param);
        }
    }

    _handleItemFormWf(item, action) {
        let _url = this._getActualUrl(action);
        let dataItem = {};

        this.fields.forEach(field => {
            dataItem[field.fieldName] = this._cloneItem(field);
            dataItem[field.fieldName].value = item[field.id];
        });

        var url = this.rootUrl + 'UIAction/GetFormWFRun?idAction=' + action.id;

        if (action.command != null && action.command.trim() != '') {
            let paramsMap = JSON.parse(action.command);
            let params = {};
            if (paramsMap.length > 0) {
                paramsMap.forEach(param => {
                    params[param] = dataItem[param].value;
                });
            }

            url += '&parameters=' + JSON.stringify(params);
        } else {
            let paramsMap = this.getURLParams(_url);
            let params = {};
            if (paramsMap.length > 0) {
                paramsMap.forEach(param => {
                    params[param] = dataItem[param].value;
                });
            }

            url += '&parameters=' + JSON.stringify(params);
        }

        if ((this.parent == null && this.displayContext != 'modal') || (this.parent != null && this.parent.context != 'modal')) {
            $.pjax({ url: url, container: '#js-page-content', timeout: 10000 })
        } else {
            this._initModal(url);
        }
    }

    _getActualUrl(command) {
        let actualUrl = '';

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href = "') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('Href = "') + 'Href = "'.length);
            actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

            command.attr = command.attr.replaceAll('Href = "' + actualUrl + '"', 'Href = "#"');
            command.attr += ' actual-url="' + actualUrl + '"';
        }

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href="') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('Href="') + 'Href="'.length);
            actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

            command.attr = command.attr.replaceAll('Href="' + actualUrl + '"', 'Href="#"');
            command.attr += ' actual-url="' + actualUrl + '"';
        }

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('actual-url="') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('actual-url="') + 'actual-url="'.length);
            actualUrl = urlPart.substr(0, urlPart.indexOf('"'));
        }

        return actualUrl;
    }

    _cloneItem(item) {
        return JSON.parse(JSON.stringify(item));
    }

    handleDelete(item) {
        confirmDialog.fire({
            title: this.getEntityFormResources('DeleteItemTitle'),
            text: this.getEntityFormResources('DeleteItemContent'),
            allowOutsideClick: false
        }).then((result) => {
            if (result.value) {
                let url = this.rootUrl + 'Entity/DeleteData';
                let data = {
                    pkVal: item[this.idField].toString(),
                    idEntity: this.entityId,
                    idExtConn: this.idExtConn
                };

                $.ajax({
                    type: "POST",
                    url: url,
                    async: true,
                    data: JSON.stringify(data),
                    contentType: "application/json; charset=utf-8",
                    headers: {
                        'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
                    },
                    success: (result) => {
                        if (this.listType == 'CAROUSEL') {
                            $('#' + this.listControlId)[0].innerHTML = '';
                            this._initCarouselControl();
                        } else {
                            this._getGridControl().dataSource.read();
                        }
                    },
                    error: (e) => {
                        toastr.error(this.getEntityFormResources('RemoveItemError'));
                    }
                });
            }
        });
    }

    handleEdit(item, action) {
        let url = this.editItemUrl;
        if (url == null || url == "") {
            url = this.rootUrl + 'EntityForm/EntityFormRuntime';
            if (this.idExtConn = null) {
                url += '?idExtConn=' + this.idExtConn;
            }
        } else {
            if (url.indexOf(this.rootUrl) == -1) {
                url = this.rootUrl + url.substring(1);
            }
        }

        url = this.replaceUrlTokens(url);

        url = url.replaceAll("[id]", item[this.idField].toString());
        url = url.replaceAll("[pkVal]", item[this.idField].toString());

        let itemKeys = Object.keys(item).filter(row => { return row.indexOf("fld_") == 0; });

        itemKeys.forEach(itemKey => {
            url = url.replaceAll('{' + itemKey + '}', item[itemKey]);
        });

        let uiContent = {};

        if (action.uiContent != null && action.uiContent.trim() != '') {
            uiContent = JSON.parse(action.uiContent);
        }

        let isAlwaysModal = uiContent.isAlwaysModal != null ? uiContent.isAlwaysModal : false;

        if (this.parent != null) {
            let _sublistMetadata = this.parent.getFieldMetadataByUniqueId(this.containerId);
            if (_sublistMetadata != null && _sublistMetadata.CtlProps != null && _sublistMetadata.CtlProps.Target != null && _sublistMetadata.CtlProps.Target != '') {
                if (this._openInTarget(url, _sublistMetadata.CtlProps.Target)) { return; }
            }
        }

        if (((this.parent == null && this.displayContext != 'modal') || (this.parent != null && this.parent.context != 'modal')) && !isAlwaysModal) {
            $.pjax({ url: url, container: '#js-page-content', timeout: 10000, contentType: 'application/json' })
        } else {
            let width = null;
            let height = null;

            if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != null) {
                width = uiContent.modalWidth;
            }

            if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != null) {
                height = uiContent.modalHeight;
            }

            this._initModal(url, width, height, this.editItemPostParam);
        }
    }

    handleView(item, command) {
        let actualUrl = '';

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href = "') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('Href = "') + 'Href = "'.length);
            actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

            command.attr = command.attr.replaceAll('Href = "' + actualUrl + '"', 'Href = "#"');
            command.attr += ' actual-url="' + actualUrl + '"';
        }

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href="') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('Href="') + 'Href="'.length);
            actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

            command.attr = command.attr.replaceAll('Href="' + actualUrl + '"', 'Href="#"');
            command.attr += ' actual-url="' + actualUrl + '"';
        }

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('actual-url="') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('actual-url="') + 'actual-url="'.length);
            actualUrl = urlPart.substr(0, urlPart.indexOf('"'));
        }

        if (actualUrl.indexOf('/') == 0 && actualUrl.indexOf(this.rootUrl) == -1) {
            actualUrl = this.rootUrl + actualUrl.substr(1);
        }

        if (actualUrl == null || actualUrl == "") {
            actualUrl = this.rootUrl + 'EntityForm/EntityFormRuntime';
            if (this.idExtConn = null) {
                url += '?idExtConn=' + this.idExtConn;
            }
        } else {
            if (actualUrl.indexOf(this.rootUrl) == -1) {
                actualUrl = this.rootUrl + actualUrl.substring(1);
            }
        }

        actualUrl = this.replaceUrlTokens(actualUrl);

        actualUrl = actualUrl.replaceAll("[id]", item[this.idField].toString());
        actualUrl = actualUrl.replaceAll("[pkVal]", item[this.idField].toString());

        let itemKeys = Object.keys(item).filter(row => { return row.indexOf("fld_") == 0; });

        itemKeys.forEach(itemKey => {
            actualUrl = actualUrl.replaceAll('{' + itemKey + '}', item[itemKey]);
        });


        if (actualUrl.indexOf('idApp') < 0) {
            actualUrl += '&idApp=' + xapp.currentApp;
        }

        let uiContent = {};

        if (command.uiContent != null && command.uiContent.trim() != '') {
            uiContent = JSON.parse(command.uiContent);
        }

        let isAlwaysModal = uiContent.isAlwaysModal != null ? uiContent.isAlwaysModal : false;

        if (this.parent != null) {
            let _sublistMetadata = this.parent.getFieldMetadataByUniqueId(this.containerId);
            if (_sublistMetadata != null && _sublistMetadata.CtlProps != null && _sublistMetadata.CtlProps.Target != null && _sublistMetadata.CtlProps.Target != '') {
                if (this._openInTarget(actualUrl, _sublistMetadata.CtlProps.Target)) { return; }
            }
        }

        if (((this.parent == null && this.displayContext != 'modal') || (this.parent != null && this.parent.context != 'modal')) && !isAlwaysModal) {
            $.pjax({ url: actualUrl, container: '#js-page-content', timeout: 10000, contentType: 'application/json' })
        } else {
            let width = null;
            let height = null;

            if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != null) {
                width = uiContent.modalWidth;
            }

            if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != null) {
                height = uiContent.modalHeight;
            }

            this._initModal(actualUrl, width, height);
        }
    }

    _openInTarget(url, target) {
        url += '&context=modal&parentGuid=' + this.uniqueControlId;
        let containerSelector = '[ui-name="' + target + '"]';
        if ($(containerSelector).length > 0) {
            $.pjax({ url: url, container: containerSelector, timeout: 10000, contentType: 'application/json', push: false });
            return true;
        }
        return false;
    }

    closeChild() {
        if (this.parent != null) {
            let _sublistMetadata = this.parent.getFieldMetadataByUniqueId(this.containerId);
            if (_sublistMetadata != null && _sublistMetadata.CtlProps != null && _sublistMetadata.CtlProps.Target != null && _sublistMetadata.CtlProps.Target != '') {
                $('[ui-name="' + _sublistMetadata.CtlProps.Target + '"]').empty();
            } else {
                this.closeModal();
            }
        } else {
            this.closeModal();
        }
    }

    handleReport(item, command) {
        let actualUrl = '';

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href = "') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('Href = "') + 'Href = "'.length);
            actualUrl = urlPart.substr(0, urlPart.lastIndexOf('"'));
        }

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href="') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('Href="') + 'Href="'.length);
            actualUrl = urlPart.substr(0, urlPart.lastIndexOf('"'));
        }

        if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('actual-url="') >= 0) {
            let urlPart = command.attr.substr(command.attr.indexOf('actual-url="') + 'actual-url="'.length);
            actualUrl = urlPart.substr(0, urlPart.lastIndexOf('"'));
        }

        if (actualUrl.indexOf('/') == 0 && actualUrl.indexOf(this.rootUrl) == -1) {
            actualUrl = this.rootUrl + actualUrl.substr(1);
        }

        actualUrl = this.replaceUrlTokens(actualUrl);

        actualUrl = actualUrl.replaceAll("[id]", item[this.idField].toString());
        actualUrl = actualUrl.replaceAll("[pkVal]", item[this.idField].toString());

        let itemKeys = Object.keys(item).filter(row => { return row.indexOf("fld_") == 0; });

        itemKeys.forEach(itemKey => {
            actualUrl = actualUrl.replaceAll('{' + itemKey + '}', item[itemKey]);
        });

        let itemWithFields = this.convertFieldToItem(item);
        let fieldKeys = Object.keys(itemWithFields);
        fieldKeys.forEach(itemKey => {
            if (actualUrl.indexOf('{' + itemKey + '}') >= 0) {
                actualUrl = actualUrl.replaceAll('{' + itemKey + '}', itemWithFields[itemKey].value);
            }
        });

        if (actualUrl.indexOf('idApp') < 0) {
            actualUrl += '&idApp=' + xapp.currentApp;
        }

        let uiContent = {};

        if (command.uiContent != null && command.uiContent.trim() != '') {
            uiContent = JSON.parse(command.uiContent);
        }

        let isAlwaysModal = uiContent.isAlwaysModal != null ? uiContent.isAlwaysModal : false;

        if (((this.parent == null && this.displayContext != 'modal') || (this.parent != null && this.parent.context != 'modal')) && !isAlwaysModal) {
            window.open(actualUrl + '&context=modal', '_blank');
        } else {
            let width = null;
            let height = null;

            if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != null) {
                width = uiContent.modalWidth;
            }

            if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != null) {
                height = uiContent.modalHeight;
            }

            this._initModal(actualUrl, width, height);
        }
    }

    parseAttrString(attrString) {
        const el = document.createElement("div");

        // wrap in a dummy tag so the browser parses attributes
        el.innerHTML = `<span ${attrString}></span>`;

        const span = el.firstChild;
        const result = {};

        for (const attr of span.attributes) {
            result[attr.name] = attr.value;
        }

        return result;
    }

    getActionColumn(useStickyColumns) {
        if (this.itemActions == null || this.itemActions.length == 0) {
            return null;
        }

        let actionColumn = {
            title: this.getGeneralResource('Actions'),
            attributes: {
                style: 'text-align: center; text-overflow: clip;'
            },
            locked: useStickyColumns
        };

        let commands = [];

        const ref = this;

        this.itemActions.forEach(itemAction => {
            if (itemAction.triggerType != null && itemAction.triggerType != 'DEFAULT') { return; }

            var clickAction = itemAction.click;

            let className = '';

            if (itemAction.attr != null && itemAction.attr.length > 0 && itemAction.attr.indexOf('class="') >= 0) {
                let classPart = itemAction.attr.substr(itemAction.attr.indexOf('class="') + 'class="'.length);
                let actualClass = classPart.substr(0, classPart.indexOf('"'));
                className = actualClass;
            }

            //CG: handler-ul de vizibilitate e o fabrica - primeste lista si intoarce predicatul de rand;
            //aici era `=` in loc de `==`, deci rezultatul se scria peste global si listele urmatoare din pagina nu mai gaseau fabrica
            let visibleHandler = itemAction.visible != null ? window[itemAction.visible] : undefined;
            if (typeof visibleHandler === 'function') { visibleHandler = visibleHandler(this); }

            let command = {
                attr: itemAction.attr,
                name: itemAction.name,
                text: itemAction.text,
                iconClass: itemAction.iconClass,
                imageClass: itemAction.iconClass,
                icon: itemAction.iconClass,
                resizable: false,
                className: className,
                visible: visibleHandler
            };

            if (this.listType == 'TREE') {
                let attrs = this.parseAttrString(itemAction.attr);
                let classList = '';
                let title = '';

                if (attrs && attrs.class) {
                    classList = attrs.class + ' ';
                }

                if (attrs && attrs.title) {
                    title = attrs.title;
                }

                command.template = `<button title="` + title + `" data-command="` + itemAction.name + `" class="` + classList + `k-button-solid-base k-button k-button-md k-rounded-md k-button-solid k-icon-button" type="button"><span class="k-icon k-svg-icon ` + itemAction.iconClass + ` k-button-icon"></span></button>`;

            }

            if (clickAction != null) {
                command.click = function (e) {
                    e.preventDefault();
                    let dataItem = this.dataItem($(e.currentTarget).closest("tr"));

                    itemAction.id = itemAction.name.replaceAll('custom_', '');

                    ref.handleItemAction(dataItem, clickAction, itemAction);
                };
            } else {
                let actualUrl = '';

                if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href = "') >= 0) {
                    let urlPart = command.attr.substr(command.attr.indexOf('Href = "') + 'Href = "'.length);
                    actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

                    command.attr = command.attr.replaceAll('Href = "' + actualUrl + '"', 'Href = "#"');
                }

                if (command.attr != null && command.attr.length > 0 && command.attr.indexOf('Href="') >= 0) {
                    let urlPart = command.attr.substr(command.attr.indexOf('Href="') + 'Href="'.length);
                    actualUrl = urlPart.substr(0, urlPart.indexOf('"'));

                    command.attr = command.attr.replaceAll('Href="' + actualUrl + '"', 'Href="#"');
                }

                if (actualUrl.indexOf('/') == 0 && actualUrl.indexOf(this.rootUrl) == -1) {
                    actualUrl = this.rootUrl + actualUrl.substr(1);
                }

                command.click = function (e) {
                    e.preventDefault();
                    let dataItem = this.dataItem($(e.currentTarget).closest("tr"));
                    ref.handleItemAction(dataItem, actualUrl, itemAction);
                };
            }

            commands.push(command);
        });

        if (commands.length == 0) {
            return null;
        }

        actionColumn.command = commands;

        if (commands.length == 1) {
            actionColumn.width = 64;
        } else {
            actionColumn.width = (commands.length * 2 * 18);
        }

        return actionColumn;
    }

    getPageable() {
        if (this.pageType == 'NONE' || this.isPreview || this.listType == 'TREE') {
            return false;
        } else {
            let pageable = {};
            pageable.pageSizes = this.pageable.pageSizes;
            return pageable;
        }
    }

    getSortable() {
        switch (this.sortType) {
            case 'none': return false;
            case 'simple': return {
                mode: 'single',
                allowUnsort: true,
                showIndexes: true
            };
            case 'multiple': return {
                mode: 'multiple',
                allowUnsort: true,
                showIndexes: true
            };
            case 'mixed': return {
                mode: 'mixed',
                allowUnsort: true,
                showIndexes: true
            };
        }

        return false;
    }

    extractFields(fields) {
        let result = [];
        fields.forEach(item => {
            let fieldId = this.fieldPrefix + item.Id;
            let field = {
                controlType: item.ControlType,
                description: item.Description,
                groupable: item.Groupable,
                id: fieldId.replaceAll('-', '_'),
                name: item.Name,
                sortable: item.Sortable,
                width: item.Width != null && item.Width != 0 ? item.Width * 16 : 160,
                htmlAttributes: item.HtmlAttributes,
                fieldDataType: item.FieldDataType != null ? item.FieldDataType : item.DataType,
                fieldDataSubType: item.DataSubType,
                fieldSpecialFieldType: item.SpecialFieldType,
                fieldIdEntityField: item.IdEntityField,
                fieldName: item.FieldName,
                templateJs: (item.Template != null && item.Template != '') ? item.Template.Js : null,
                templateHtml: (item.Template != null && item.Template != '') ? item.Template.Html : null,
                hidden: item.Hidden
            };

            if (item.DataType == 'BOOLEAN' || item.DataType == 'BOOLINT') {
                field.boolFormat = item.DisplayFormat;
                if (field.boolFormat == null || field.boolFormat == '') {
                    //asta duce pe traducerea implicita din resurse
                    field.boolFormat = "-";
                }
            } else {
                field.format = item.DisplayFormat;
            }

            result.push(field);
        });

        return result;
    }

    getGeneralResource(name) {
        if (this.generalResources[name] != null && this.generalResources[name].trim() != '') {
            return this.generalResources[name];
        }

        return name;
    }

    replaceUrlTokens(url) {
        if (this.urlParameters != null && this.urlParameters.length > 0) {
            let keys = Object.keys(this.urlParameters);

            keys.forEach(key => {
                url = url.replaceAll('{' + key + '}', this.urlParameters[key]);
            });
        }

        return url;
    }

    getEntityFormResources(name) {
        if (this.entityFormResources[name] != null && this.entityFormResources[name].trim() != '') {
            return this.entityFormResources[name];
        }

        return name;
    }

    getLayoutResource(name) {
        if (this.layoutResources[name] != null && this.layoutResources[name].trim() != '') {
            return this.layoutResources[name];
        }

        return name;
    }

    applyStyles() {
        if (!this.styleApplied) {
            this.applyListStyle('.k-grid-content.k-auto-scrollable', 'overflow-y', 'hidden', 'important');
            this.applyListStyle('.k-grid-header', 'padding', '0px 0px 0px 0px', 'important');
            this.applyListStyle('.k-grid-header', 'margin-left', '1px');
            this.applyListStyle('.k-grid-header', 'flex-flow', 'row-reverse');
            this.applyListStyle('.k-widget.k-combobox.k-combobox-clearable', 'width', '100%');

            this.applyListStyle('.k-grid-content-locked', 'margin-right', '1px');
            this.applyListStyle('.k-grid-content-locked', 'margin-bottom', '-1px');
            this.applyListStyle('.k-grid-content-locked', 'height', 'auto', 'important');
            this.applyListStyle('.k-grid-content-locked', 'margin-top', '-1px');
            this.applyListStyle('.k-grid-content-locked', 'min-height', '3.35rem');
            this.applyListStyle('.k-grid-content-locked table', 'min-height', '3.2rem');

            this.applyListStyle('.k-grid-content.k-auto-scrollable', 'margin-left', '1px');
            if (this.listType != 'CAROUSEL') {
                this.applyListStyle(null, 'margin-top', '0');
            }
            this.applyListStyle('.k-grid-toolbar', 'padding-bottom', '0.8rem');
            this.applyListStyle('.k-grid-toolbar', 'padding-top', '0.5rem');
            this.applyListStyle('.k-grid-toolbar', 'padding-right', '0.5rem');
            this.applyListStyle('.k-grid-toolbar', 'padding-left', '0.5rem');
            this.applyListStyle('.k-grid-toolbar', 'padding-left', '0px');
            this.applyListStyle('.k-grid-toolbar', 'padding-right', '0px');
            this.applyListStyle('.k-grid-content-locked', 'float', 'right');
            this.applyListStyle('.k-grid-header-locked', 'float', 'right');
            this.applyListStyle('.k-grid-content.k-auto-scrollable', 'padding-bottom', '0.5px', 'important');

            this.applyListStyle('.k-grid-header', 'border-width', '0px', 'important');
            this.applyListStyle('.k-grid-content.k-auto-scrollable [role="grid"]', 'border-top-width', '0px', 'important');
            this.applyListStyle('.k-grid-content.k-auto-scrollable [role="grid"]', 'border-right-width', '0px', 'important');
            this.applyListStyle('.k-grid-header-wrap.k-auto-scrollable [role="grid"]', 'border-right-width', '0px', 'important');
            this.applyListStyle('.k-grid-content.k-auto-scrollable [role="grid"]', 'margin-bottom', '0px', 'important');

            if ($('body')[0].classList.contains('mod-skin-dark')) {
                this.applyListStyle('.k-grid-header-wrap.k-auto-scrollable', 'border-left', '1px solid #a5abb1', 'important');
                this.applyListStyle('.k-grid-header-wrap.k-auto-scrollable  [role="grid"]', 'border-left-width', '0px', 'important');

                this.applyListStyle('.k-grid-content.k-auto-scrollable', 'border-left', '1px solid #a5abb1', 'important');
                this.applyListStyle('.k-grid-content.k-auto-scrollable  [role="grid"]', 'border-left-width', '0px', 'important');
                this.applyListStyle('.k-grid-norecords', 'border-bottom', '1px solid #a5abb1', 'important');
            } else {
                this.applyListStyle('.k-grid-header-wrap.k-auto-scrollable', 'border-left', '1px solid #dddde5', 'important');
                this.applyListStyle('.k-grid-header-wrap.k-auto-scrollable  [role="grid"]', 'border-left-width', '0px', 'important');

                this.applyListStyle('.k-grid-content.k-auto-scrollable', 'border-left', '1px solid #dddde5', 'important');
                this.applyListStyle('.k-grid-content.k-auto-scrollable  [role="grid"]', 'border-left-width', '0px', 'important');
                this.applyListStyle('.k-grid-norecords', 'border-bottom', '1px solid #dddde5', 'important');
            }

            this.applyListStyle('.k-grid-header-locked table', 'border-left-width', '0px', 'important');
            this.applyListStyle('.k-grid-content-locked table', 'border-top-color', 'transparent', 'important');

            if (this.parent == null) {
                this.applyStyle('#' + this.containerId, 'background-color', 'inherit');
            } else {
                this.applyStyle('#' + this.containerId + ' .k-grid-toolbar', 'background-color', 'transparent');
                this.applyStyle('#' + this.containerId + ' .k-grid-pager', 'background-color', 'transparent');
            }

            if (this._checkMobile()) {
                this.applyListStyle('.k-grid-search', 'width', '100%', 'important');
                this.applyListStyle('.k-grid-search', 'margin-left', '0', 'important');
                this.applyListStyle('.k-button-icontext', 'margin-top', '1rem', 'important');
            }

            this.styleApplied = true;
        } else {
            if ($('.k-grid-header-locked').length > 0 && $('.k-grid-header-locked')[0].style.width != null && $('.k-grid-header-locked')[0].style.width != '') {
                let newWidth = new Number($('.k-grid-header-locked')[0].style.width.replaceAll('px', ''));

                if (newWidth != this.lastHeaderWidth) {
                    this.lastHeaderWidth = newWidth - 1;
                    this.applyListStyle('.k-grid-header-locked', 'width', this.lastHeaderWidth + 'px', 'important');
                    this.applyListStyle('.k-grid-header-locked', 'margin-right', '1px', 'important');
                }
            }
        }
    }

    applyListStyle(selector, property, value, extra) {
        if (selector != null) {
            this.applyStyle('#' + this.listControlId + ' ' + selector, property, value, extra);
        } else {
            this.applyStyle('#' + this.listControlId, property, value, extra);
        }
    }

    applyStyle(selector, property, value, extra) {
        try {
            let elements = document.querySelectorAll(selector);
            if (elements) {
                elements.forEach(element => {
                    if (extra) {
                        element.style.setProperty(property, value, extra);
                    } else {
                        element.style.setProperty(property, value);
                    }
                });
            }
        } catch {

        }
    }
}
